//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class CatalogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param divisionId (optional) 
     * @return OK
     */
    getCatalogCategories(divisionId: string | undefined): Observable<GetCatalogCategoriesResponse> {
        let url_ = this.baseUrl + "/catalog/categories?";
        if (divisionId === null)
            throw new globalThis.Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCatalogCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCatalogCategoriesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCatalogCategoriesResponse>;
        }));
    }

    protected processGetCatalogCategories(response: HttpResponseBase): Observable<GetCatalogCategoriesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCatalogCategoriesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createCatalogCategory(body: CreateCatalogCategoryModel): Observable<void> {
        let url_ = this.baseUrl + "/catalog/categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCatalogCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCatalogCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCatalogCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deleteCatalogCategory(id: string): Observable<void> {
        let url_ = this.baseUrl + "/catalog/categories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCatalogCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCatalogCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCatalogCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    editCatalogCategory(id: string, body: EditCatalogCategoryModel): Observable<void> {
        let url_ = this.baseUrl + "/catalog/categories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCatalogCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCatalogCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditCatalogCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param divisionId (optional) 
     * @return OK
     */
    getCatalogItems(divisionId: string | undefined): Observable<GetCatalogItemsResponse> {
        let url_ = this.baseUrl + "/catalog/items?";
        if (divisionId === null)
            throw new globalThis.Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCatalogItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCatalogItemsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCatalogItemsResponse>;
        }));
    }

    protected processGetCatalogItems(response: HttpResponseBase): Observable<GetCatalogItemsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCatalogItemsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createCatalogItem(body: CreateCatalogItemModel): Observable<void> {
        let url_ = this.baseUrl + "/catalog/items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCatalogItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCatalogItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCatalogItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCatalogItemTemplatesByItem(catalogItemId: string): Observable<GetCatalogItemTemplatesByItemResponse> {
        let url_ = this.baseUrl + "/catalog/items/{catalogItemId}/templates";
        if (catalogItemId === undefined || catalogItemId === null)
            throw new globalThis.Error("The parameter 'catalogItemId' must be defined.");
        url_ = url_.replace("{catalogItemId}", encodeURIComponent("" + catalogItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCatalogItemTemplatesByItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogItemTemplatesByItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCatalogItemTemplatesByItemResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCatalogItemTemplatesByItemResponse>;
        }));
    }

    protected processGetCatalogItemTemplatesByItem(response: HttpResponseBase): Observable<GetCatalogItemTemplatesByItemResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCatalogItemTemplatesByItemResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createCatalogItemTemplate(catalogItemId: string, body: CreateOrUpdateCatalogItemTemplateModel): Observable<void> {
        let url_ = this.baseUrl + "/catalog/items/{catalogItemId}/templates";
        if (catalogItemId === undefined || catalogItemId === null)
            throw new globalThis.Error("The parameter 'catalogItemId' must be defined.");
        url_ = url_.replace("{catalogItemId}", encodeURIComponent("" + catalogItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCatalogItemTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCatalogItemTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCatalogItemTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCatalogItemById(id: string): Observable<GetCatalogItemByIdResponse> {
        let url_ = this.baseUrl + "/catalog/items/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCatalogItemById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogItemById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCatalogItemByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCatalogItemByIdResponse>;
        }));
    }

    protected processGetCatalogItemById(response: HttpResponseBase): Observable<GetCatalogItemByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCatalogItemByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deleteCatalogItem(id: string): Observable<void> {
        let url_ = this.baseUrl + "/catalog/items/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCatalogItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCatalogItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCatalogItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    editCatalogItem(id: string, body: EditCatalogItemModel): Observable<void> {
        let url_ = this.baseUrl + "/catalog/items/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCatalogItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCatalogItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditCatalogItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deleteCatalogItemTemplate(id: string): Observable<void> {
        let url_ = this.baseUrl + "/catalog/templates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCatalogItemTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCatalogItemTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCatalogItemTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    updateCatalogItemTemplate(templateId: string, body: CreateOrUpdateCatalogItemTemplateModel): Observable<void> {
        let url_ = this.baseUrl + "/catalog/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCatalogItemTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCatalogItemTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCatalogItemTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CurrenciesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCurrencies(): Observable<GetCurrenciesResponse> {
        let url_ = this.baseUrl + "/currencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrencies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrenciesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrenciesResponse>;
        }));
    }

    protected processGetCurrencies(response: HttpResponseBase): Observable<GetCurrenciesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrenciesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createCurrency(body: CreateCurrencyModel): Observable<void> {
        let url_ = this.baseUrl + "/currencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCurrency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCurrency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCurrency(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    setCurrencyCountries(isoCurrencyCode: string, body: SetCurrencyCountriesModel): Observable<void> {
        let url_ = this.baseUrl + "/currencies/{isoCurrencyCode}/countries";
        if (isoCurrencyCode === undefined || isoCurrencyCode === null)
            throw new globalThis.Error("The parameter 'isoCurrencyCode' must be defined.");
        url_ = url_.replace("{isoCurrencyCode}", encodeURIComponent("" + isoCurrencyCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCurrencyCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCurrencyCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCurrencyCountries(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DirectOverheadsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return No Content
     */
    deleteDirectOverhead(id: string): Observable<void> {
        let url_ = this.baseUrl + "/direct-overheads/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDirectOverhead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDirectOverhead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDirectOverhead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    updateDirectOverhead(id: string, body: UpdateDirectOverheadModel): Observable<void> {
        let url_ = this.baseUrl + "/direct-overheads/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDirectOverhead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDirectOverhead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDirectOverhead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class Inventory_NumbersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getInventoryNumbers(): Observable<GetInventoryNumbersResponse> {
        let url_ = this.baseUrl + "/inventory-numbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInventoryNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInventoryNumbersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInventoryNumbersResponse>;
        }));
    }

    protected processGetInventoryNumbers(response: HttpResponseBase): Observable<GetInventoryNumbersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInventoryNumbersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InvestmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return No Content
     */
    deleteInvestment(id: string): Observable<void> {
        let url_ = this.baseUrl + "/investments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInvestment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInvestment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInvestment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    updateInvestment(id: string, body: UpdateInvestmentModel): Observable<void> {
        let url_ = this.baseUrl + "/investments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInvestment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInvestment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInvestment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    postponeInvestment(planId: string, investmentId: string, quantity: any): Observable<void> {
        let url_ = this.baseUrl + "/investments/postpone?";
        if (planId === undefined || planId === null)
            throw new globalThis.Error("The parameter 'planId' must be defined and cannot be null.");
        else
            url_ += "planId=" + encodeURIComponent("" + planId) + "&";
        if (investmentId === undefined || investmentId === null)
            throw new globalThis.Error("The parameter 'investmentId' must be defined and cannot be null.");
        else
            url_ += "investmentId=" + encodeURIComponent("" + investmentId) + "&";
        if (quantity === undefined || quantity === null)
            throw new globalThis.Error("The parameter 'quantity' must be defined and cannot be null.");
        else
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostponeInvestment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostponeInvestment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostponeInvestment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deletePostponedInvestment(id: string): Observable<void> {
        let url_ = this.baseUrl + "/investments/postponed/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePostponedInvestment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePostponedInvestment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePostponedInvestment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPostponedInvestments(planId: string): Observable<GetPostponedInvestmentsResponse> {
        let url_ = this.baseUrl + "/investments/postponed/{planId}";
        if (planId === undefined || planId === null)
            throw new globalThis.Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostponedInvestments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostponedInvestments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPostponedInvestmentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPostponedInvestmentsResponse>;
        }));
    }

    protected processGetPostponedInvestments(response: HttpResponseBase): Observable<GetPostponedInvestmentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPostponedInvestmentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    applyPostponedInvestment(planId: string, postponedInvestmentId: string): Observable<void> {
        let url_ = this.baseUrl + "/investments/postponed/apply?";
        if (planId === undefined || planId === null)
            throw new globalThis.Error("The parameter 'planId' must be defined and cannot be null.");
        else
            url_ += "planId=" + encodeURIComponent("" + planId) + "&";
        if (postponedInvestmentId === undefined || postponedInvestmentId === null)
            throw new globalThis.Error("The parameter 'postponedInvestmentId' must be defined and cannot be null.");
        else
            url_ += "postponedInvestmentId=" + encodeURIComponent("" + postponedInvestmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyPostponedInvestment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyPostponedInvestment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApplyPostponedInvestment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    restorePostponedInvestment(planId: string, postponedInvestmentId: string): Observable<void> {
        let url_ = this.baseUrl + "/investments/postponed/restore?";
        if (planId === undefined || planId === null)
            throw new globalThis.Error("The parameter 'planId' must be defined and cannot be null.");
        else
            url_ += "planId=" + encodeURIComponent("" + planId) + "&";
        if (postponedInvestmentId === undefined || postponedInvestmentId === null)
            throw new globalThis.Error("The parameter 'postponedInvestmentId' must be defined and cannot be null.");
        else
            url_ += "postponedInvestmentId=" + encodeURIComponent("" + postponedInvestmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestorePostponedInvestment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestorePostponedInvestment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestorePostponedInvestment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getBranchById(id: string): Observable<GetBranchByIdResponse> {
        let url_ = this.baseUrl + "/locations/branches/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBranchByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBranchByIdResponse>;
        }));
    }

    protected processGetBranchById(response: HttpResponseBase): Observable<GetBranchByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param divisionId (optional) 
     * @return OK
     */
    getCountries(divisionId: string | undefined): Observable<GetCountriesResponse> {
        let url_ = this.baseUrl + "/locations/countries?";
        if (divisionId === null)
            throw new globalThis.Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCountriesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCountriesResponse>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<GetCountriesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCountriesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getFiscalYearsByCountry(countryId: string): Observable<GetFiscalYearsByCountryResponse> {
        let url_ = this.baseUrl + "/locations/countries/{countryId}/fiscal-years";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiscalYearsByCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiscalYearsByCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFiscalYearsByCountryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFiscalYearsByCountryResponse>;
        }));
    }

    protected processGetFiscalYearsByCountry(response: HttpResponseBase): Observable<GetFiscalYearsByCountryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFiscalYearsByCountryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    editCountry(id: string, body: EditCountryModel): Observable<void> {
        let url_ = this.baseUrl + "/locations/countries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditCountry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDivisions(): Observable<GetDivisionsResponse> {
        let url_ = this.baseUrl + "/locations/divisions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDivisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDivisions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDivisionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDivisionsResponse>;
        }));
    }

    protected processGetDivisions(response: HttpResponseBase): Observable<GetDivisionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDivisionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    setBranchBudget(fiscalYearId: string, body: SetBranchBudgetModel): Observable<void> {
        let url_ = this.baseUrl + "/locations/fiscal-years/{fiscalYearId}/branch-budgets";
        if (fiscalYearId === undefined || fiscalYearId === null)
            throw new globalThis.Error("The parameter 'fiscalYearId' must be defined.");
        url_ = url_.replace("{fiscalYearId}", encodeURIComponent("" + fiscalYearId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetBranchBudget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetBranchBudget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetBranchBudget(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    setCountryBudget(fiscalYearId: string, body: SetCountryBudgetModel): Observable<void> {
        let url_ = this.baseUrl + "/locations/fiscal-years/{fiscalYearId}/country-budgets";
        if (fiscalYearId === undefined || fiscalYearId === null)
            throw new globalThis.Error("The parameter 'fiscalYearId' must be defined.");
        url_ = url_.replace("{fiscalYearId}", encodeURIComponent("" + fiscalYearId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCountryBudget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCountryBudget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCountryBudget(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getHierarchyData(hierarchyType: HierarchyType, entityId: string, fiscalYearId: string): Observable<GetHierarchyDataResponse> {
        let url_ = this.baseUrl + "/locations/hierarchy/{entityId}/data?";
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        if (hierarchyType === undefined || hierarchyType === null)
            throw new globalThis.Error("The parameter 'hierarchyType' must be defined and cannot be null.");
        else
            url_ += "hierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (fiscalYearId === undefined || fiscalYearId === null)
            throw new globalThis.Error("The parameter 'fiscalYearId' must be defined and cannot be null.");
        else
            url_ += "fiscalYearId=" + encodeURIComponent("" + fiscalYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHierarchyData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHierarchyData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHierarchyDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHierarchyDataResponse>;
        }));
    }

    protected processGetHierarchyData(response: HttpResponseBase): Observable<GetHierarchyDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHierarchyDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getHierarchyTrackingData(hierarchyType: HierarchyType, entityId: string, fiscalYearId: string): Observable<GetHierarchyTrackingDataResponse> {
        let url_ = this.baseUrl + "/locations/hierarchy/{entityId}/tracking-data?";
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        if (hierarchyType === undefined || hierarchyType === null)
            throw new globalThis.Error("The parameter 'hierarchyType' must be defined and cannot be null.");
        else
            url_ += "hierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        if (fiscalYearId === undefined || fiscalYearId === null)
            throw new globalThis.Error("The parameter 'fiscalYearId' must be defined and cannot be null.");
        else
            url_ += "fiscalYearId=" + encodeURIComponent("" + fiscalYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHierarchyTrackingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHierarchyTrackingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHierarchyTrackingDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHierarchyTrackingDataResponse>;
        }));
    }

    protected processGetHierarchyTrackingData(response: HttpResponseBase): Observable<GetHierarchyTrackingDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHierarchyTrackingDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param divisionId (optional) 
     * @return OK
     */
    getDetailedRegions(divisionId: string | undefined): Observable<GetDetailedRegionsResponse> {
        let url_ = this.baseUrl + "/locations/regions?";
        if (divisionId === null)
            throw new globalThis.Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailedRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailedRegions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDetailedRegionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDetailedRegionsResponse>;
        }));
    }

    protected processGetDetailedRegions(response: HttpResponseBase): Observable<GetDetailedRegionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDetailedRegionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getFiscalYearsByRegion(regionId: string): Observable<GetFiscalYearsByRegionResponse> {
        let url_ = this.baseUrl + "/locations/regions/{regionId}/fiscal-years";
        if (regionId === undefined || regionId === null)
            throw new globalThis.Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiscalYearsByRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiscalYearsByRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFiscalYearsByRegionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFiscalYearsByRegionResponse>;
        }));
    }

    protected processGetFiscalYearsByRegion(response: HttpResponseBase): Observable<GetFiscalYearsByRegionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFiscalYearsByRegionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    setRegionBudget(regionId: string, fiscalYearId: string, body: SetRegionBudgetModel): Observable<void> {
        let url_ = this.baseUrl + "/locations/regions/{regionId}/fiscal-years/{fiscalYearId}/budget";
        if (regionId === undefined || regionId === null)
            throw new globalThis.Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        if (fiscalYearId === undefined || fiscalYearId === null)
            throw new globalThis.Error("The parameter 'fiscalYearId' must be defined.");
        url_ = url_.replace("{fiscalYearId}", encodeURIComponent("" + fiscalYearId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetRegionBudget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetRegionBudget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetRegionBudget(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PlansClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getPlanById(id: string): Observable<GetPlanByIdResponse> {
        let url_ = this.baseUrl + "/plans/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPlanByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPlanByIdResponse>;
        }));
    }

    protected processGetPlanById(response: HttpResponseBase): Observable<GetPlanByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPlanCatalogItemsByPlan(id: string): Observable<GetPlanCatalogItemsByPlanResponse> {
        let url_ = this.baseUrl + "/plans/{id}/items";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanCatalogItemsByPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanCatalogItemsByPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPlanCatalogItemsByPlanResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPlanCatalogItemsByPlanResponse>;
        }));
    }

    protected processGetPlanCatalogItemsByPlan(response: HttpResponseBase): Observable<GetPlanCatalogItemsByPlanResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanCatalogItemsByPlanResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    sharePlan(id: string, body: SharePlanModel): Observable<void> {
        let url_ = this.baseUrl + "/plans/{id}/share";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSharePlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSharePlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSharePlan(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createDirectOverhead(planId: string, catalogItemId: string, body: CreateDirectOverheadModel): Observable<void> {
        let url_ = this.baseUrl + "/plans/{planId}/catalog-items/{catalogItemId}/direct-overhead";
        if (planId === undefined || planId === null)
            throw new globalThis.Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        if (catalogItemId === undefined || catalogItemId === null)
            throw new globalThis.Error("The parameter 'catalogItemId' must be defined.");
        url_ = url_.replace("{catalogItemId}", encodeURIComponent("" + catalogItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDirectOverhead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDirectOverhead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateDirectOverhead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createInvestment(planId: string, catalogItemId: string, body: CreateInvestmentModel): Observable<void> {
        let url_ = this.baseUrl + "/plans/{planId}/catalog-items/{catalogItemId}/investment";
        if (planId === undefined || planId === null)
            throw new globalThis.Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        if (catalogItemId === undefined || catalogItemId === null)
            throw new globalThis.Error("The parameter 'catalogItemId' must be defined.");
        url_ = url_.replace("{catalogItemId}", encodeURIComponent("" + catalogItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvestment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvestment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateInvestment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createCustomPlanItem(planId: string, name: string): Observable<void> {
        let url_ = this.baseUrl + "/plans/{planId}/custom-items?";
        if (planId === undefined || planId === null)
            throw new globalThis.Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomPlanItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomPlanItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCustomPlanItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getInvitedMembersForPlanId(planId: string): Observable<GetInvitedMembersForPlanIdResponse> {
        let url_ = this.baseUrl + "/plans/{planId}/invited-members";
        if (planId === undefined || planId === null)
            throw new globalThis.Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvitedMembersForPlanId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvitedMembersForPlanId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInvitedMembersForPlanIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInvitedMembersForPlanIdResponse>;
        }));
    }

    protected processGetInvitedMembersForPlanId(response: HttpResponseBase): Observable<GetInvitedMembersForPlanIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInvitedMembersForPlanIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    createNewPlanVersion(planId: string, body: CreateNewPlanVersionModel): Observable<CreateNewPlanVersionCommandResult> {
        let url_ = this.baseUrl + "/plans/{planId}/versions";
        if (planId === undefined || planId === null)
            throw new globalThis.Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewPlanVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewPlanVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateNewPlanVersionCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateNewPlanVersionCommandResult>;
        }));
    }

    protected processCreateNewPlanVersion(response: HttpResponseBase): Observable<CreateNewPlanVersionCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateNewPlanVersionCommandResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPlanActivities(): Observable<GetPlanActivitiesResponse> {
        let url_ = this.baseUrl + "/plans/activities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPlanActivitiesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPlanActivitiesResponse>;
        }));
    }

    protected processGetPlanActivities(response: HttpResponseBase): Observable<GetPlanActivitiesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanActivitiesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPlansByBranchId(branchId: string): Observable<GetPlansByBranchIdResponse> {
        let url_ = this.baseUrl + "/plans/branch/{branchId}";
        if (branchId === undefined || branchId === null)
            throw new globalThis.Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlansByBranchId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlansByBranchId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPlansByBranchIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPlansByBranchIdResponse>;
        }));
    }

    protected processGetPlansByBranchId(response: HttpResponseBase): Observable<GetPlansByBranchIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlansByBranchIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param planId (optional) 
     * @param branchId (optional) 
     * @param countryId (optional) 
     * @param regionId (optional) 
     * @param fiscalYearId (optional) 
     * @return OK
     */
    export(planId: string | undefined, branchId: string | undefined, countryId: string | undefined, regionId: string | undefined, fiscalYearId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/plans/export?";
        if (planId === null)
            throw new globalThis.Error("The parameter 'planId' cannot be null.");
        else if (planId !== undefined)
            url_ += "planId=" + encodeURIComponent("" + planId) + "&";
        if (branchId === null)
            throw new globalThis.Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        if (countryId === null)
            throw new globalThis.Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (regionId === null)
            throw new globalThis.Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        if (fiscalYearId === null)
            throw new globalThis.Error("The parameter 'fiscalYearId' cannot be null.");
        else if (fiscalYearId !== undefined)
            url_ += "fiscalYearId=" + encodeURIComponent("" + fiscalYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param divisionId (optional) 
     * @return OK
     */
    getFiscalYears(divisionId: string | undefined): Observable<GetFiscalYearsResponse> {
        let url_ = this.baseUrl + "/plans/fiscal-years?";
        if (divisionId === null)
            throw new globalThis.Error("The parameter 'divisionId' cannot be null.");
        else if (divisionId !== undefined)
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiscalYears(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiscalYears(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFiscalYearsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFiscalYearsResponse>;
        }));
    }

    protected processGetFiscalYears(response: HttpResponseBase): Observable<GetFiscalYearsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFiscalYearsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createFiscalYear(body: CreateFiscalYearModel): Observable<void> {
        let url_ = this.baseUrl + "/plans/fiscal-years";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFiscalYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFiscalYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateFiscalYear(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    notifyHeadsOfCountry(fiscalYearId: string, body: NotifyHeadsOfCountryModel): Observable<NotifyHeadsOfCountryCommandResult> {
        let url_ = this.baseUrl + "/plans/fiscal-years/{fiscalYearId}/notify-heads-of-country";
        if (fiscalYearId === undefined || fiscalYearId === null)
            throw new globalThis.Error("The parameter 'fiscalYearId' must be defined.");
        url_ = url_.replace("{fiscalYearId}", encodeURIComponent("" + fiscalYearId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyHeadsOfCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyHeadsOfCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotifyHeadsOfCountryCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotifyHeadsOfCountryCommandResult>;
        }));
    }

    protected processNotifyHeadsOfCountry(response: HttpResponseBase): Observable<NotifyHeadsOfCountryCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotifyHeadsOfCountryCommandResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPlanItemById(planItemId: string): Observable<GetPlanItemByIdResponse> {
        let url_ = this.baseUrl + "/plans/items/{planItemId}";
        if (planItemId === undefined || planItemId === null)
            throw new globalThis.Error("The parameter 'planItemId' must be defined.");
        url_ = url_.replace("{planItemId}", encodeURIComponent("" + planItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanItemById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanItemById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPlanItemByIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPlanItemByIdResponse>;
        }));
    }

    protected processGetPlanItemById(response: HttpResponseBase): Observable<GetPlanItemByIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanItemByIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createDirectOverheadForCustomItem(planItemId: string, body: CreateDirectOverheadModel): Observable<void> {
        let url_ = this.baseUrl + "/plans/items/{planItemId}/direct-overhead";
        if (planItemId === undefined || planItemId === null)
            throw new globalThis.Error("The parameter 'planItemId' must be defined.");
        url_ = url_.replace("{planItemId}", encodeURIComponent("" + planItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDirectOverheadForCustomItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDirectOverheadForCustomItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateDirectOverheadForCustomItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createInvestmentForCustomItem(planItemId: string, body: CreateInvestmentModel): Observable<void> {
        let url_ = this.baseUrl + "/plans/items/{planItemId}/investment";
        if (planItemId === undefined || planItemId === null)
            throw new globalThis.Error("The parameter 'planItemId' must be defined.");
        url_ = url_.replace("{planItemId}", encodeURIComponent("" + planItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvestmentForCustomItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvestmentForCustomItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateInvestmentForCustomItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createConversationMessage(planItemId: string, body: CreateConversationMessageModel): Observable<void> {
        let url_ = this.baseUrl + "/plans/items/{planItemId}/message";
        if (planItemId === undefined || planItemId === null)
            throw new globalThis.Error("The parameter 'planItemId' must be defined.");
        url_ = url_.replace("{planItemId}", encodeURIComponent("" + planItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConversationMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConversationMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateConversationMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPlansByUserId(): Observable<GetPlansByUserIdResponse> {
        let url_ = this.baseUrl + "/plans/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlansByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlansByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPlansByUserIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPlansByUserIdResponse>;
        }));
    }

    protected processGetPlansByUserId(response: HttpResponseBase): Observable<GetPlansByUserIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlansByUserIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPlanTasksForUser(): Observable<GetPlanTasksForUserResponse> {
        let url_ = this.baseUrl + "/plans/tasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanTasksForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanTasksForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPlanTasksForUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPlanTasksForUserResponse>;
        }));
    }

    protected processGetPlanTasksForUser(response: HttpResponseBase): Observable<GetPlanTasksForUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanTasksForUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TrackingEntriesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return No Content
     */
    updateTrackingEntry(id: string, date: Date, amount: any, cost: any): Observable<void> {
        let url_ = this.baseUrl + "/tracking-entries/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (amount === undefined || amount === null)
            throw new globalThis.Error("The parameter 'amount' must be defined and cannot be null.");
        else
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        if (cost === undefined || cost === null)
            throw new globalThis.Error("The parameter 'cost' must be defined and cannot be null.");
        else
            url_ += "cost=" + encodeURIComponent("" + cost) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTrackingEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTrackingEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTrackingEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    deleteTrackingEntry(id: string): Observable<void> {
        let url_ = this.baseUrl + "/tracking-entries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTrackingEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTrackingEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTrackingEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    createTrackingEntry(investmentId: string, date: Date, amount: any, cost: any): Observable<void> {
        let url_ = this.baseUrl + "/tracking-entries/{investmentId}?";
        if (investmentId === undefined || investmentId === null)
            throw new globalThis.Error("The parameter 'investmentId' must be defined.");
        url_ = url_.replace("{investmentId}", encodeURIComponent("" + investmentId));
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (amount === undefined || amount === null)
            throw new globalThis.Error("The parameter 'amount' must be defined and cannot be null.");
        else
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        if (cost === undefined || cost === null)
            throw new globalThis.Error("The parameter 'cost' must be defined and cannot be null.");
        else
            url_ += "cost=" + encodeURIComponent("" + cost) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTrackingEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTrackingEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTrackingEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getTrackingEntries(investmentId: string): Observable<GetTrackingEntriesResponse> {
        let url_ = this.baseUrl + "/tracking-entries/by-investment/{investmentId}";
        if (investmentId === undefined || investmentId === null)
            throw new globalThis.Error("The parameter 'investmentId' must be defined.");
        url_ = url_.replace("{investmentId}", encodeURIComponent("" + investmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrackingEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrackingEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTrackingEntriesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTrackingEntriesResponse>;
        }));
    }

    protected processGetTrackingEntries(response: HttpResponseBase): Observable<GetTrackingEntriesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTrackingEntriesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    replaceTrackingEntries(investmentId: string, body: ReplaceTrackingEntryItemRequest[]): Observable<void> {
        let url_ = this.baseUrl + "/tracking-entries/by-investment/{investmentId}";
        if (investmentId === undefined || investmentId === null)
            throw new globalThis.Error("The parameter 'investmentId' must be defined.");
        url_ = url_.replace("{investmentId}", encodeURIComponent("" + investmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceTrackingEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceTrackingEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReplaceTrackingEntries(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TranslationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getTranslations(): Observable<GetTranslationsResponse> {
        let url_ = this.baseUrl + "/translations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranslations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranslations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTranslationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTranslationsResponse>;
        }));
    }

    protected processGetTranslations(response: HttpResponseBase): Observable<GetTranslationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTranslationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getLanguages(): Observable<GetLanguagesResponse> {
        let url_ = this.baseUrl + "/translations/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesResponse>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllUsers(): Observable<GetAllUsersResponse> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllUsersResponse>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<GetAllUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    createUser(body: CreateUserModel): Observable<CreateUserCommandResult> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateUserCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateUserCommandResult>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<CreateUserCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateUserCommandResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    resendUserInvitation(id: string): Observable<void> {
        let url_ = this.baseUrl + "/users/{id}/invitation";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendUserInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendUserInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendUserInvitation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    assignUserToBranch(userId: string, branchId: string): Observable<void> {
        let url_ = this.baseUrl + "/users/assignments/branches?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (branchId === undefined || branchId === null)
            throw new globalThis.Error("The parameter 'branchId' must be defined and cannot be null.");
        else
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserToBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserToBranch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignUserToBranch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    removeUserFromBranch(userId: string, branchId: string): Observable<void> {
        let url_ = this.baseUrl + "/users/assignments/branches?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (branchId === undefined || branchId === null)
            throw new globalThis.Error("The parameter 'branchId' must be defined and cannot be null.");
        else
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromBranch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromBranch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    assignUserToCountry(userId: string, countryId: string): Observable<void> {
        let url_ = this.baseUrl + "/users/assignments/countries?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined and cannot be null.");
        else
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserToCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserToCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignUserToCountry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    removeUserFromCountry(userId: string, countryId: string): Observable<void> {
        let url_ = this.baseUrl + "/users/assignments/countries?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined and cannot be null.");
        else
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromCountry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    assignUserToDivision(userId: string, divisionId: string): Observable<void> {
        let url_ = this.baseUrl + "/users/assignments/divisions?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (divisionId === undefined || divisionId === null)
            throw new globalThis.Error("The parameter 'divisionId' must be defined and cannot be null.");
        else
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserToDivision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserToDivision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignUserToDivision(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    removeUserFromDivision(userId: string, divisionId: string): Observable<void> {
        let url_ = this.baseUrl + "/users/assignments/divisions?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (divisionId === undefined || divisionId === null)
            throw new globalThis.Error("The parameter 'divisionId' must be defined and cannot be null.");
        else
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromDivision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromDivision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromDivision(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    assignUserToRegion(userId: string, regionId: string): Observable<void> {
        let url_ = this.baseUrl + "/users/assignments/regions?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (regionId === undefined || regionId === null)
            throw new globalThis.Error("The parameter 'regionId' must be defined and cannot be null.");
        else
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserToRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserToRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignUserToRegion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    removeUserFromRegion(userId: string, regionId: string): Observable<void> {
        let url_ = this.baseUrl + "/users/assignments/regions?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (regionId === undefined || regionId === null)
            throw new globalThis.Error("The parameter 'regionId' must be defined and cannot be null.");
        else
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromRegion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCurrentUser(): Observable<GetCurrentUserResponse> {
        let url_ = this.baseUrl + "/users/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentUserResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentUserResponse>;
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<GetCurrentUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    updateCurrentUserLanguage(languageCode: string): Observable<void> {
        let url_ = this.baseUrl + "/users/current/language?";
        if (languageCode === undefined || languageCode === null)
            throw new globalThis.Error("The parameter 'languageCode' must be defined and cannot be null.");
        else
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    syncDistributionLists(): Observable<DistributionListSyncResult> {
        let url_ = this.baseUrl + "/users/distribution-lists/sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncDistributionLists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncDistributionLists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistributionListSyncResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistributionListSyncResult>;
        }));
    }

    protected processSyncDistributionLists(response: HttpResponseBase): Observable<DistributionListSyncResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistributionListSyncResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUserHierarchy(divisionId: string): Observable<GetUserHierarchyResponse> {
        let url_ = this.baseUrl + "/users/hierarchy?";
        if (divisionId === undefined || divisionId === null)
            throw new globalThis.Error("The parameter 'divisionId' must be defined and cannot be null.");
        else
            url_ += "divisionId=" + encodeURIComponent("" + divisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserHierarchy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserHierarchy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserHierarchyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserHierarchyResponse>;
        }));
    }

    protected processGetUserHierarchy(response: HttpResponseBase): Observable<GetUserHierarchyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserHierarchyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return No Content
     */
    syncUser(body: SyncUserModel): Observable<void> {
        let url_ = this.baseUrl + "/users/sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSyncUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Entity", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum AvailabilityState {
    Existing = "Existing",
    Insufficient = "Insufficient",
    NotExisting = "NotExisting",
    NotApplicable = "NotApplicable",
}

export class BranchBudgetItemModel implements IBranchBudgetItemModel {
    branchId!: string;
    amount!: any | null;

    constructor(data?: IBranchBudgetItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static fromJS(data: any): BranchBudgetItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchBudgetItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId !== undefined ? this.branchId : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        return data;
    }
}

export interface IBranchBudgetItemModel {
    branchId: string;
    amount: any | null;
}

export class BranchModel implements IBranchModel {
    id!: string;
    identifier!: string;
    name!: string;

    constructor(data?: IBranchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.identifier = _data["identifier"] !== undefined ? _data["identifier"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): BranchModel {
        data = typeof data === 'object' ? data : {};
        let result = new BranchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["identifier"] = this.identifier !== undefined ? this.identifier : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IBranchModel {
    id: string;
    identifier: string;
    name: string;
}

export class CatalogCategoryModel implements ICatalogCategoryModel {
    id!: string;
    name!: string;
    nameTranslations!: TranslationEntryModel[];
    code!: string;

    constructor(data?: ICatalogCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.nameTranslations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["nameTranslations"])) {
                this.nameTranslations = [] as any;
                for (let item of _data["nameTranslations"])
                    this.nameTranslations!.push(TranslationEntryModel.fromJS(item));
            }
            else {
                this.nameTranslations = null as any;
            }
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
        }
    }

    static fromJS(data: any): CatalogCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.nameTranslations)) {
            data["nameTranslations"] = [];
            for (let item of this.nameTranslations)
                data["nameTranslations"].push(item ? item.toJSON() : null as any);
        }
        data["code"] = this.code !== undefined ? this.code : null as any;
        return data;
    }
}

export interface ICatalogCategoryModel {
    id: string;
    name: string;
    nameTranslations: TranslationEntryModel[];
    code: string;
}

export class CatalogItemModel implements ICatalogItemModel {
    id!: string;
    name!: string;
    nameTranslations!: TranslationEntryModel[];
    identifier!: string;
    itemNumber!: any;
    templatesCount!: any;
    inventoryNumber!: string;
    catalogCategoryId!: string;

    constructor(data?: ICatalogItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.nameTranslations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["nameTranslations"])) {
                this.nameTranslations = [] as any;
                for (let item of _data["nameTranslations"])
                    this.nameTranslations!.push(TranslationEntryModel.fromJS(item));
            }
            else {
                this.nameTranslations = null as any;
            }
            this.identifier = _data["identifier"] !== undefined ? _data["identifier"] : null as any;
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : null as any;
            this.templatesCount = _data["templatesCount"] !== undefined ? _data["templatesCount"] : null as any;
            this.inventoryNumber = _data["inventoryNumber"] !== undefined ? _data["inventoryNumber"] : null as any;
            this.catalogCategoryId = _data["catalogCategoryId"] !== undefined ? _data["catalogCategoryId"] : null as any;
        }
    }

    static fromJS(data: any): CatalogItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.nameTranslations)) {
            data["nameTranslations"] = [];
            for (let item of this.nameTranslations)
                data["nameTranslations"].push(item ? item.toJSON() : null as any);
        }
        data["identifier"] = this.identifier !== undefined ? this.identifier : null as any;
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : null as any;
        data["templatesCount"] = this.templatesCount !== undefined ? this.templatesCount : null as any;
        data["inventoryNumber"] = this.inventoryNumber !== undefined ? this.inventoryNumber : null as any;
        data["catalogCategoryId"] = this.catalogCategoryId !== undefined ? this.catalogCategoryId : null as any;
        return data;
    }
}

export interface ICatalogItemModel {
    id: string;
    name: string;
    nameTranslations: TranslationEntryModel[];
    identifier: string;
    itemNumber: any;
    templatesCount: any;
    inventoryNumber: string;
    catalogCategoryId: string;
}

export class CatalogItemTemplateModel implements ICatalogItemTemplateModel {
    id!: string;
    countryId!: string;
    country!: string;
    isoCurrencyCode!: string;
    cost!: any | null;
    lifetimeInMonths!: any | null;
    estimatedDeliveryTime!: string | null;
    availabilityState!: AvailabilityState | null;

    constructor(data?: ICatalogItemTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.isoCurrencyCode = _data["isoCurrencyCode"] !== undefined ? _data["isoCurrencyCode"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.lifetimeInMonths = _data["lifetimeInMonths"] !== undefined ? _data["lifetimeInMonths"] : null as any;
            this.estimatedDeliveryTime = _data["estimatedDeliveryTime"] !== undefined ? _data["estimatedDeliveryTime"] : null as any;
            this.availabilityState = _data["availabilityState"] !== undefined ? _data["availabilityState"] : null as any;
        }
    }

    static fromJS(data: any): CatalogItemTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogItemTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["isoCurrencyCode"] = this.isoCurrencyCode !== undefined ? this.isoCurrencyCode : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["lifetimeInMonths"] = this.lifetimeInMonths !== undefined ? this.lifetimeInMonths : null as any;
        data["estimatedDeliveryTime"] = this.estimatedDeliveryTime !== undefined ? this.estimatedDeliveryTime : null as any;
        data["availabilityState"] = this.availabilityState !== undefined ? this.availabilityState : null as any;
        return data;
    }
}

export interface ICatalogItemTemplateModel {
    id: string;
    countryId: string;
    country: string;
    isoCurrencyCode: string;
    cost: any | null;
    lifetimeInMonths: any | null;
    estimatedDeliveryTime: string | null;
    availabilityState: AvailabilityState | null;
}

export class ConversationMessageModel implements IConversationMessageModel {
    content!: string;
    username!: string;
    createdAt!: Date;
    profilePictureUrl!: string | null;

    constructor(data?: IConversationMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : null as any;
            this.profilePictureUrl = _data["profilePictureUrl"] !== undefined ? _data["profilePictureUrl"] : null as any;
        }
    }

    static fromJS(data: any): ConversationMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : null as any;
        data["profilePictureUrl"] = this.profilePictureUrl !== undefined ? this.profilePictureUrl : null as any;
        return data;
    }
}

export interface IConversationMessageModel {
    content: string;
    username: string;
    createdAt: Date;
    profilePictureUrl: string | null;
}

export class CountryBudgetItemModel implements ICountryBudgetItemModel {
    countryId!: string;
    amount!: any | null;

    constructor(data?: ICountryBudgetItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static fromJS(data: any): CountryBudgetItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryBudgetItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        return data;
    }
}

export interface ICountryBudgetItemModel {
    countryId: string;
    amount: any | null;
}

export class CountryModel implements ICountryModel {
    id!: string;
    countryCode!: string;
    countryName!: string;
    divisionName!: string;
    regionId!: string;
    isoCurrencyCodes!: string[];
    mainIsoCurrencyCode!: string;

    constructor(data?: ICountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.isoCurrencyCodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : null as any;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null as any;
            this.divisionName = _data["divisionName"] !== undefined ? _data["divisionName"] : null as any;
            this.regionId = _data["regionId"] !== undefined ? _data["regionId"] : null as any;
            if (Array.isArray(_data["isoCurrencyCodes"])) {
                this.isoCurrencyCodes = [] as any;
                for (let item of _data["isoCurrencyCodes"])
                    this.isoCurrencyCodes!.push(item);
            }
            else {
                this.isoCurrencyCodes = null as any;
            }
            this.mainIsoCurrencyCode = _data["mainIsoCurrencyCode"] !== undefined ? _data["mainIsoCurrencyCode"] : null as any;
        }
    }

    static fromJS(data: any): CountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : null as any;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null as any;
        data["divisionName"] = this.divisionName !== undefined ? this.divisionName : null as any;
        data["regionId"] = this.regionId !== undefined ? this.regionId : null as any;
        if (Array.isArray(this.isoCurrencyCodes)) {
            data["isoCurrencyCodes"] = [];
            for (let item of this.isoCurrencyCodes)
                data["isoCurrencyCodes"].push(item);
        }
        data["mainIsoCurrencyCode"] = this.mainIsoCurrencyCode !== undefined ? this.mainIsoCurrencyCode : null as any;
        return data;
    }
}

export interface ICountryModel {
    id: string;
    countryCode: string;
    countryName: string;
    divisionName: string;
    regionId: string;
    isoCurrencyCodes: string[];
    mainIsoCurrencyCode: string;
}

export class CreateCatalogCategoryModel implements ICreateCatalogCategoryModel {
    name!: string;
    code!: string;
    isoLanguageCode!: string;
    divisionId!: string | null;

    constructor(data?: ICreateCatalogCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.isoLanguageCode = _data["isoLanguageCode"] !== undefined ? _data["isoLanguageCode"] : null as any;
            this.divisionId = _data["divisionId"] !== undefined ? _data["divisionId"] : null as any;
        }
    }

    static fromJS(data: any): CreateCatalogCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCatalogCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["isoLanguageCode"] = this.isoLanguageCode !== undefined ? this.isoLanguageCode : null as any;
        data["divisionId"] = this.divisionId !== undefined ? this.divisionId : null as any;
        return data;
    }
}

export interface ICreateCatalogCategoryModel {
    name: string;
    code: string;
    isoLanguageCode: string;
    divisionId: string | null;
}

export class CreateCatalogItemModel implements ICreateCatalogItemModel {
    isoLanguageCode!: string;
    name!: string;
    categoryId!: string;
    inventoryNumberId!: string;

    constructor(data?: ICreateCatalogItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isoLanguageCode = _data["isoLanguageCode"] !== undefined ? _data["isoLanguageCode"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : null as any;
            this.inventoryNumberId = _data["inventoryNumberId"] !== undefined ? _data["inventoryNumberId"] : null as any;
        }
    }

    static fromJS(data: any): CreateCatalogItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCatalogItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isoLanguageCode"] = this.isoLanguageCode !== undefined ? this.isoLanguageCode : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : null as any;
        data["inventoryNumberId"] = this.inventoryNumberId !== undefined ? this.inventoryNumberId : null as any;
        return data;
    }
}

export interface ICreateCatalogItemModel {
    isoLanguageCode: string;
    name: string;
    categoryId: string;
    inventoryNumberId: string;
}

export class CreateConversationMessageModel implements ICreateConversationMessageModel {
    content!: string;

    constructor(data?: ICreateConversationMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
        }
    }

    static fromJS(data: any): CreateConversationMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConversationMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content !== undefined ? this.content : null as any;
        return data;
    }
}

export interface ICreateConversationMessageModel {
    content: string;
}

export class CreateCurrencyModel implements ICreateCurrencyModel {
    isoCurrencyCode!: string;

    constructor(data?: ICreateCurrencyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isoCurrencyCode = _data["isoCurrencyCode"] !== undefined ? _data["isoCurrencyCode"] : null as any;
        }
    }

    static fromJS(data: any): CreateCurrencyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCurrencyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isoCurrencyCode"] = this.isoCurrencyCode !== undefined ? this.isoCurrencyCode : null as any;
        return data;
    }
}

export interface ICreateCurrencyModel {
    isoCurrencyCode: string;
}

export class CreateDirectOverheadModel implements ICreateDirectOverheadModel {
    quantity!: any;
    estimatedCost!: any;
    estimatedDate!: Date;

    constructor(data?: ICreateDirectOverheadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.estimatedCost = _data["estimatedCost"] !== undefined ? _data["estimatedCost"] : null as any;
            this.estimatedDate = _data["estimatedDate"] ? new Date(_data["estimatedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CreateDirectOverheadModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDirectOverheadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["estimatedCost"] = this.estimatedCost !== undefined ? this.estimatedCost : null as any;
        data["estimatedDate"] = this.estimatedDate ? formatDate(this.estimatedDate) : null as any;
        return data;
    }
}

export interface ICreateDirectOverheadModel {
    quantity: any;
    estimatedCost: any;
    estimatedDate: Date;
}

export class CreateFiscalYearModel implements ICreateFiscalYearModel {
    year!: any;
    latestPlanSubmissionDate!: Date;
    countryId!: string | null;
    divisionId!: string | null;
    countryIds!: string[] | null;

    constructor(data?: ICreateFiscalYearModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.latestPlanSubmissionDate = _data["latestPlanSubmissionDate"] ? new Date(_data["latestPlanSubmissionDate"].toString()) : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.divisionId = _data["divisionId"] !== undefined ? _data["divisionId"] : null as any;
            if (Array.isArray(_data["countryIds"])) {
                this.countryIds = [] as any;
                for (let item of _data["countryIds"])
                    this.countryIds!.push(item);
            }
            else {
                this.countryIds = null as any;
            }
        }
    }

    static fromJS(data: any): CreateFiscalYearModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFiscalYearModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["latestPlanSubmissionDate"] = this.latestPlanSubmissionDate ? formatDate(this.latestPlanSubmissionDate) : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["divisionId"] = this.divisionId !== undefined ? this.divisionId : null as any;
        if (Array.isArray(this.countryIds)) {
            data["countryIds"] = [];
            for (let item of this.countryIds)
                data["countryIds"].push(item);
        }
        return data;
    }
}

export interface ICreateFiscalYearModel {
    year: any;
    latestPlanSubmissionDate: Date;
    countryId: string | null;
    divisionId: string | null;
    countryIds: string[] | null;
}

export class CreateInvestmentModel implements ICreateInvestmentModel {
    quantity!: any;
    priority!: ItemPriority;
    lifetimeInMonths!: any;
    estimatedCost!: any;
    estimatedDate!: Date;

    constructor(data?: ICreateInvestmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.lifetimeInMonths = _data["lifetimeInMonths"] !== undefined ? _data["lifetimeInMonths"] : null as any;
            this.estimatedCost = _data["estimatedCost"] !== undefined ? _data["estimatedCost"] : null as any;
            this.estimatedDate = _data["estimatedDate"] ? new Date(_data["estimatedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CreateInvestmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvestmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["lifetimeInMonths"] = this.lifetimeInMonths !== undefined ? this.lifetimeInMonths : null as any;
        data["estimatedCost"] = this.estimatedCost !== undefined ? this.estimatedCost : null as any;
        data["estimatedDate"] = this.estimatedDate ? formatDate(this.estimatedDate) : null as any;
        return data;
    }
}

export interface ICreateInvestmentModel {
    quantity: any;
    priority: ItemPriority;
    lifetimeInMonths: any;
    estimatedCost: any;
    estimatedDate: Date;
}

export class CreateNewPlanVersionCommandResult implements ICreateNewPlanVersionCommandResult {
    newPlanId!: string;

    constructor(data?: ICreateNewPlanVersionCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPlanId = _data["newPlanId"] !== undefined ? _data["newPlanId"] : null as any;
        }
    }

    static fromJS(data: any): CreateNewPlanVersionCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewPlanVersionCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPlanId"] = this.newPlanId !== undefined ? this.newPlanId : null as any;
        return data;
    }
}

export interface ICreateNewPlanVersionCommandResult {
    newPlanId: string;
}

export class CreateNewPlanVersionModel implements ICreateNewPlanVersionModel {
    targetState!: PlanState;
    changesRequestedMessage!: string | null;

    constructor(data?: ICreateNewPlanVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetState = _data["targetState"] !== undefined ? _data["targetState"] : null as any;
            this.changesRequestedMessage = _data["changesRequestedMessage"] !== undefined ? _data["changesRequestedMessage"] : null as any;
        }
    }

    static fromJS(data: any): CreateNewPlanVersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewPlanVersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetState"] = this.targetState !== undefined ? this.targetState : null as any;
        data["changesRequestedMessage"] = this.changesRequestedMessage !== undefined ? this.changesRequestedMessage : null as any;
        return data;
    }
}

export interface ICreateNewPlanVersionModel {
    targetState: PlanState;
    changesRequestedMessage: string | null;
}

export class CreateOrUpdateCatalogItemTemplateModel implements ICreateOrUpdateCatalogItemTemplateModel {
    countryId!: string;
    isoCurrencyCode!: string;
    cost!: any;
    lifetimeInMonths!: any | null;
    deliveryTimeInMonths!: string;
    availabilityState!: AvailabilityState;

    constructor(data?: ICreateOrUpdateCatalogItemTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.isoCurrencyCode = _data["isoCurrencyCode"] !== undefined ? _data["isoCurrencyCode"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.lifetimeInMonths = _data["lifetimeInMonths"] !== undefined ? _data["lifetimeInMonths"] : null as any;
            this.deliveryTimeInMonths = _data["deliveryTimeInMonths"] !== undefined ? _data["deliveryTimeInMonths"] : null as any;
            this.availabilityState = _data["availabilityState"] !== undefined ? _data["availabilityState"] : null as any;
        }
    }

    static fromJS(data: any): CreateOrUpdateCatalogItemTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCatalogItemTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["isoCurrencyCode"] = this.isoCurrencyCode !== undefined ? this.isoCurrencyCode : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["lifetimeInMonths"] = this.lifetimeInMonths !== undefined ? this.lifetimeInMonths : null as any;
        data["deliveryTimeInMonths"] = this.deliveryTimeInMonths !== undefined ? this.deliveryTimeInMonths : null as any;
        data["availabilityState"] = this.availabilityState !== undefined ? this.availabilityState : null as any;
        return data;
    }
}

export interface ICreateOrUpdateCatalogItemTemplateModel {
    countryId: string;
    isoCurrencyCode: string;
    cost: any;
    lifetimeInMonths: any | null;
    deliveryTimeInMonths: string;
    availabilityState: AvailabilityState;
}

export class CreateUserAssignmentModel implements ICreateUserAssignmentModel {
    level!: UserAssignmentLevel;
    locationId!: string;

    constructor(data?: ICreateUserAssignmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
        }
    }

    static fromJS(data: any): CreateUserAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserAssignmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        return data;
    }
}

export interface ICreateUserAssignmentModel {
    level: UserAssignmentLevel;
    locationId: string;
}

export class CreateUserCommandResult implements ICreateUserCommandResult {
    userId!: string;

    constructor(data?: ICreateUserCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
        }
    }

    static fromJS(data: any): CreateUserCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        return data;
    }
}

export interface ICreateUserCommandResult {
    userId: string;
}

export class CreateUserModel implements ICreateUserModel {
    email!: string;
    assignment!: CreateUserAssignmentModel | null;

    constructor(data?: ICreateUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.assignment = _data["assignment"] ? CreateUserAssignmentModel.fromJS(_data["assignment"]) : null as any;
        }
    }

    static fromJS(data: any): CreateUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["assignment"] = this.assignment ? this.assignment.toJSON() : null as any;
        return data;
    }
}

export interface ICreateUserModel {
    email: string;
    assignment: CreateUserAssignmentModel | null;
}

export class CurrencyModel implements ICurrencyModel {
    isoCurrencyCode!: string;
    currencySymbol!: string;

    constructor(data?: ICurrencyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isoCurrencyCode = _data["isoCurrencyCode"] !== undefined ? _data["isoCurrencyCode"] : null as any;
            this.currencySymbol = _data["currencySymbol"] !== undefined ? _data["currencySymbol"] : null as any;
        }
    }

    static fromJS(data: any): CurrencyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isoCurrencyCode"] = this.isoCurrencyCode !== undefined ? this.isoCurrencyCode : null as any;
        data["currencySymbol"] = this.currencySymbol !== undefined ? this.currencySymbol : null as any;
        return data;
    }
}

export interface ICurrencyModel {
    isoCurrencyCode: string;
    currencySymbol: string;
}

export class DetailedRegionModel implements IDetailedRegionModel {
    id!: string;
    name!: string;
    canViewDashboard!: boolean;
    countries!: MinimalCountryModel[];

    constructor(data?: IDetailedRegionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.countries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.canViewDashboard = _data["canViewDashboard"] !== undefined ? _data["canViewDashboard"] : null as any;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(MinimalCountryModel.fromJS(item));
            }
            else {
                this.countries = null as any;
            }
        }
    }

    static fromJS(data: any): DetailedRegionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DetailedRegionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["canViewDashboard"] = this.canViewDashboard !== undefined ? this.canViewDashboard : null as any;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IDetailedRegionModel {
    id: string;
    name: string;
    canViewDashboard: boolean;
    countries: MinimalCountryModel[];
}

export class DistributionListSyncResult implements IDistributionListSyncResult {
    syncedLists!: any;
    failedLists!: any;
    addedAssignments!: any;
    removedAssignments!: any;

    constructor(data?: IDistributionListSyncResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncedLists = _data["syncedLists"] !== undefined ? _data["syncedLists"] : null as any;
            this.failedLists = _data["failedLists"] !== undefined ? _data["failedLists"] : null as any;
            this.addedAssignments = _data["addedAssignments"] !== undefined ? _data["addedAssignments"] : null as any;
            this.removedAssignments = _data["removedAssignments"] !== undefined ? _data["removedAssignments"] : null as any;
        }
    }

    static fromJS(data: any): DistributionListSyncResult {
        data = typeof data === 'object' ? data : {};
        let result = new DistributionListSyncResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncedLists"] = this.syncedLists !== undefined ? this.syncedLists : null as any;
        data["failedLists"] = this.failedLists !== undefined ? this.failedLists : null as any;
        data["addedAssignments"] = this.addedAssignments !== undefined ? this.addedAssignments : null as any;
        data["removedAssignments"] = this.removedAssignments !== undefined ? this.removedAssignments : null as any;
        return data;
    }
}

export interface IDistributionListSyncResult {
    syncedLists: any;
    failedLists: any;
    addedAssignments: any;
    removedAssignments: any;
}

export class DivisionModel implements IDivisionModel {
    id!: string;
    code!: string;
    name!: string;

    constructor(data?: IDivisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): DivisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IDivisionModel {
    id: string;
    code: string;
    name: string;
}

export class DohModel implements IDohModel {
    id!: string;
    quantity!: any;
    estimatedCost!: any | null;
    actualCost!: any | null;
    estimatedDate!: Date | null;
    realizedDate!: Date | null;

    constructor(data?: IDohModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.estimatedCost = _data["estimatedCost"] !== undefined ? _data["estimatedCost"] : null as any;
            this.actualCost = _data["actualCost"] !== undefined ? _data["actualCost"] : null as any;
            this.estimatedDate = _data["estimatedDate"] ? new Date(_data["estimatedDate"].toString()) : null as any;
            this.realizedDate = _data["realizedDate"] ? new Date(_data["realizedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): DohModel {
        data = typeof data === 'object' ? data : {};
        let result = new DohModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["estimatedCost"] = this.estimatedCost !== undefined ? this.estimatedCost : null as any;
        data["actualCost"] = this.actualCost !== undefined ? this.actualCost : null as any;
        data["estimatedDate"] = this.estimatedDate ? formatDate(this.estimatedDate) : null as any;
        data["realizedDate"] = this.realizedDate ? formatDate(this.realizedDate) : null as any;
        return data;
    }
}

export interface IDohModel {
    id: string;
    quantity: any;
    estimatedCost: any | null;
    actualCost: any | null;
    estimatedDate: Date | null;
    realizedDate: Date | null;
}

export class EditCatalogCategoryModel implements IEditCatalogCategoryModel {
    nameTranslations!: TranslationEntryModel[] | null;

    constructor(data?: IEditCatalogCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nameTranslations"])) {
                this.nameTranslations = [] as any;
                for (let item of _data["nameTranslations"])
                    this.nameTranslations!.push(TranslationEntryModel.fromJS(item));
            }
            else {
                this.nameTranslations = null as any;
            }
        }
    }

    static fromJS(data: any): EditCatalogCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditCatalogCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nameTranslations)) {
            data["nameTranslations"] = [];
            for (let item of this.nameTranslations)
                data["nameTranslations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IEditCatalogCategoryModel {
    nameTranslations: TranslationEntryModel[] | null;
}

export class EditCatalogItemModel implements IEditCatalogItemModel {
    nameTranslations!: TranslationEntryModel[] | null;

    constructor(data?: IEditCatalogItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nameTranslations"])) {
                this.nameTranslations = [] as any;
                for (let item of _data["nameTranslations"])
                    this.nameTranslations!.push(TranslationEntryModel.fromJS(item));
            }
            else {
                this.nameTranslations = null as any;
            }
        }
    }

    static fromJS(data: any): EditCatalogItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditCatalogItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nameTranslations)) {
            data["nameTranslations"] = [];
            for (let item of this.nameTranslations)
                data["nameTranslations"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IEditCatalogItemModel {
    nameTranslations: TranslationEntryModel[] | null;
}

export class EditCountryModel implements IEditCountryModel {
    mainIsoCurrencyCode!: string;

    constructor(data?: IEditCountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainIsoCurrencyCode = _data["mainIsoCurrencyCode"] !== undefined ? _data["mainIsoCurrencyCode"] : null as any;
        }
    }

    static fromJS(data: any): EditCountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditCountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainIsoCurrencyCode"] = this.mainIsoCurrencyCode !== undefined ? this.mainIsoCurrencyCode : null as any;
        return data;
    }
}

export interface IEditCountryModel {
    mainIsoCurrencyCode: string;
}

export class FiscalYearCountryModel implements IFiscalYearCountryModel {
    countryId!: string;
    name!: string;
    isPlanned!: boolean;
    hasPlans!: boolean;
    headOfCountryCount!: any;
    lastNotifiedAt!: Date | null;

    constructor(data?: IFiscalYearCountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.isPlanned = _data["isPlanned"] !== undefined ? _data["isPlanned"] : null as any;
            this.hasPlans = _data["hasPlans"] !== undefined ? _data["hasPlans"] : null as any;
            this.headOfCountryCount = _data["headOfCountryCount"] !== undefined ? _data["headOfCountryCount"] : null as any;
            this.lastNotifiedAt = _data["lastNotifiedAt"] ? new Date(_data["lastNotifiedAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): FiscalYearCountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new FiscalYearCountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["isPlanned"] = this.isPlanned !== undefined ? this.isPlanned : null as any;
        data["hasPlans"] = this.hasPlans !== undefined ? this.hasPlans : null as any;
        data["headOfCountryCount"] = this.headOfCountryCount !== undefined ? this.headOfCountryCount : null as any;
        data["lastNotifiedAt"] = this.lastNotifiedAt ? this.lastNotifiedAt.toISOString() : null as any;
        return data;
    }
}

export interface IFiscalYearCountryModel {
    countryId: string;
    name: string;
    isPlanned: boolean;
    hasPlans: boolean;
    headOfCountryCount: any;
    lastNotifiedAt: Date | null;
}

export class FiscalYearModel implements IFiscalYearModel {
    id!: string;
    year!: any;
    plannedCountryNames!: string[];
    hasGlobalPlan!: boolean;
    countries!: FiscalYearCountryModel[];

    constructor(data?: IFiscalYearModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.plannedCountryNames = [];
            this.countries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            if (Array.isArray(_data["plannedCountryNames"])) {
                this.plannedCountryNames = [] as any;
                for (let item of _data["plannedCountryNames"])
                    this.plannedCountryNames!.push(item);
            }
            else {
                this.plannedCountryNames = null as any;
            }
            this.hasGlobalPlan = _data["hasGlobalPlan"] !== undefined ? _data["hasGlobalPlan"] : null as any;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(FiscalYearCountryModel.fromJS(item));
            }
            else {
                this.countries = null as any;
            }
        }
    }

    static fromJS(data: any): FiscalYearModel {
        data = typeof data === 'object' ? data : {};
        let result = new FiscalYearModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["year"] = this.year !== undefined ? this.year : null as any;
        if (Array.isArray(this.plannedCountryNames)) {
            data["plannedCountryNames"] = [];
            for (let item of this.plannedCountryNames)
                data["plannedCountryNames"].push(item);
        }
        data["hasGlobalPlan"] = this.hasGlobalPlan !== undefined ? this.hasGlobalPlan : null as any;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFiscalYearModel {
    id: string;
    year: any;
    plannedCountryNames: string[];
    hasGlobalPlan: boolean;
    countries: FiscalYearCountryModel[];
}

export class GetAllUsersResponse implements IGetAllUsersResponse {
    data!: UserListItemModel[] | null;

    constructor(data?: IGetAllUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserListItemModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetAllUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetAllUsersResponse {
    data: UserListItemModel[] | null;
}

export class GetBranchByIdResponse implements IGetBranchByIdResponse {
    data!: BranchModel | null;

    constructor(data?: IGetBranchByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? BranchModel.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): GetBranchByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }
}

export interface IGetBranchByIdResponse {
    data: BranchModel | null;
}

export class GetCatalogCategoriesResponse implements IGetCatalogCategoriesResponse {
    data!: CatalogCategoryModel[] | null;

    constructor(data?: IGetCatalogCategoriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CatalogCategoryModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetCatalogCategoriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCatalogCategoriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetCatalogCategoriesResponse {
    data: CatalogCategoryModel[] | null;
}

export class GetCatalogItemByIdResponse implements IGetCatalogItemByIdResponse {
    data!: MinimalCatalogItemModel | null;

    constructor(data?: IGetCatalogItemByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? MinimalCatalogItemModel.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): GetCatalogItemByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCatalogItemByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }
}

export interface IGetCatalogItemByIdResponse {
    data: MinimalCatalogItemModel | null;
}

export class GetCatalogItemsResponse implements IGetCatalogItemsResponse {
    data!: CatalogItemModel[] | null;

    constructor(data?: IGetCatalogItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CatalogItemModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetCatalogItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCatalogItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetCatalogItemsResponse {
    data: CatalogItemModel[] | null;
}

export class GetCatalogItemTemplatesByItemResponse implements IGetCatalogItemTemplatesByItemResponse {
    data!: CatalogItemTemplateModel[] | null;

    constructor(data?: IGetCatalogItemTemplatesByItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CatalogItemTemplateModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetCatalogItemTemplatesByItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCatalogItemTemplatesByItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetCatalogItemTemplatesByItemResponse {
    data: CatalogItemTemplateModel[] | null;
}

export class GetCountriesResponse implements IGetCountriesResponse {
    data!: CountryModel[] | null;

    constructor(data?: IGetCountriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CountryModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetCountriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetCountriesResponse {
    data: CountryModel[] | null;
}

export class GetCurrenciesResponse implements IGetCurrenciesResponse {
    data!: CurrencyModel[] | null;

    constructor(data?: IGetCurrenciesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CurrencyModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetCurrenciesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrenciesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetCurrenciesResponse {
    data: CurrencyModel[] | null;
}

export class GetCurrentUserResponse implements IGetCurrentUserResponse {
    data!: UserModel | null;

    constructor(data?: IGetCurrentUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserModel.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): GetCurrentUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }
}

export interface IGetCurrentUserResponse {
    data: UserModel | null;
}

export class GetDetailedRegionsResponse implements IGetDetailedRegionsResponse {
    data!: DetailedRegionModel[] | null;

    constructor(data?: IGetDetailedRegionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DetailedRegionModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetDetailedRegionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDetailedRegionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetDetailedRegionsResponse {
    data: DetailedRegionModel[] | null;
}

export class GetDivisionsResponse implements IGetDivisionsResponse {
    data!: DivisionModel[] | null;

    constructor(data?: IGetDivisionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DivisionModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetDivisionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDivisionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetDivisionsResponse {
    data: DivisionModel[] | null;
}

export class GetFiscalYearsByCountryResponse implements IGetFiscalYearsByCountryResponse {
    data!: MinimalFiscalYearModel[] | null;

    constructor(data?: IGetFiscalYearsByCountryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MinimalFiscalYearModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetFiscalYearsByCountryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFiscalYearsByCountryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetFiscalYearsByCountryResponse {
    data: MinimalFiscalYearModel[] | null;
}

export class GetFiscalYearsByRegionResponse implements IGetFiscalYearsByRegionResponse {
    data!: MinimalFiscalYearModel[] | null;

    constructor(data?: IGetFiscalYearsByRegionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MinimalFiscalYearModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetFiscalYearsByRegionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFiscalYearsByRegionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetFiscalYearsByRegionResponse {
    data: MinimalFiscalYearModel[] | null;
}

export class GetFiscalYearsResponse implements IGetFiscalYearsResponse {
    data!: FiscalYearModel[] | null;

    constructor(data?: IGetFiscalYearsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FiscalYearModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetFiscalYearsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFiscalYearsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetFiscalYearsResponse {
    data: FiscalYearModel[] | null;
}

export class GetHierarchyDataResponse implements IGetHierarchyDataResponse {
    data!: HierarchyDataModel | null;

    constructor(data?: IGetHierarchyDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? HierarchyDataModel.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): GetHierarchyDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHierarchyDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }
}

export interface IGetHierarchyDataResponse {
    data: HierarchyDataModel | null;
}

export class GetHierarchyTrackingDataResponse implements IGetHierarchyTrackingDataResponse {
    data!: HierarchyTrackingDataModel | null;

    constructor(data?: IGetHierarchyTrackingDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? HierarchyTrackingDataModel.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): GetHierarchyTrackingDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetHierarchyTrackingDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }
}

export interface IGetHierarchyTrackingDataResponse {
    data: HierarchyTrackingDataModel | null;
}

export class GetInventoryNumbersResponse implements IGetInventoryNumbersResponse {
    data!: InventoryNumberModel[] | null;

    constructor(data?: IGetInventoryNumbersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InventoryNumberModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetInventoryNumbersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInventoryNumbersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetInventoryNumbersResponse {
    data: InventoryNumberModel[] | null;
}

export class GetInvitedMembersForPlanIdResponse implements IGetInvitedMembersForPlanIdResponse {
    data!: InvitedMemberModel[] | null;

    constructor(data?: IGetInvitedMembersForPlanIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(InvitedMemberModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetInvitedMembersForPlanIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvitedMembersForPlanIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetInvitedMembersForPlanIdResponse {
    data: InvitedMemberModel[] | null;
}

export class GetLanguagesResponse implements IGetLanguagesResponse {
    data!: LanguageModel[] | null;

    constructor(data?: IGetLanguagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LanguageModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetLanguagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetLanguagesResponse {
    data: LanguageModel[] | null;
}

export class GetPlanActivitiesResponse implements IGetPlanActivitiesResponse {
    data!: PlanActivityModel[] | null;

    constructor(data?: IGetPlanActivitiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PlanActivityModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetPlanActivitiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanActivitiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetPlanActivitiesResponse {
    data: PlanActivityModel[] | null;
}

export class GetPlanByIdResponse implements IGetPlanByIdResponse {
    data!: PlanModel | null;

    constructor(data?: IGetPlanByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PlanModel.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): GetPlanByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }
}

export interface IGetPlanByIdResponse {
    data: PlanModel | null;
}

export class GetPlanCatalogItemsByPlanResponse implements IGetPlanCatalogItemsByPlanResponse {
    data!: PlanCatalogItemModel[] | null;

    constructor(data?: IGetPlanCatalogItemsByPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PlanCatalogItemModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetPlanCatalogItemsByPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanCatalogItemsByPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetPlanCatalogItemsByPlanResponse {
    data: PlanCatalogItemModel[] | null;
}

export class GetPlanItemByIdResponse implements IGetPlanItemByIdResponse {
    data!: PlanCatalogItemModel | null;

    constructor(data?: IGetPlanItemByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PlanCatalogItemModel.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): GetPlanItemByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanItemByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }
}

export interface IGetPlanItemByIdResponse {
    data: PlanCatalogItemModel | null;
}

export class GetPlansByBranchIdResponse implements IGetPlansByBranchIdResponse {
    data!: PlanListEntryModel[] | null;

    constructor(data?: IGetPlansByBranchIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PlanListEntryModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetPlansByBranchIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlansByBranchIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetPlansByBranchIdResponse {
    data: PlanListEntryModel[] | null;
}

export class GetPlansByUserIdResponse implements IGetPlansByUserIdResponse {
    data!: PlanByUserModel[] | null;

    constructor(data?: IGetPlansByUserIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PlanByUserModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetPlansByUserIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlansByUserIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetPlansByUserIdResponse {
    data: PlanByUserModel[] | null;
}

export class GetPlanTasksForUserResponse implements IGetPlanTasksForUserResponse {
    data!: PlanTaskModel[] | null;

    constructor(data?: IGetPlanTasksForUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PlanTaskModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetPlanTasksForUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanTasksForUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetPlanTasksForUserResponse {
    data: PlanTaskModel[] | null;
}

export class GetPostponedInvestmentsResponse implements IGetPostponedInvestmentsResponse {
    data!: PostponedInvestmentsDataModel | null;

    constructor(data?: IGetPostponedInvestmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PostponedInvestmentsDataModel.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): GetPostponedInvestmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPostponedInvestmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }
}

export interface IGetPostponedInvestmentsResponse {
    data: PostponedInvestmentsDataModel | null;
}

export class GetTrackingEntriesResponse implements IGetTrackingEntriesResponse {
    data!: TrackingEntryModel[] | null;

    constructor(data?: IGetTrackingEntriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TrackingEntryModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetTrackingEntriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrackingEntriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetTrackingEntriesResponse {
    data: TrackingEntryModel[] | null;
}

export class GetTranslationsResponse implements IGetTranslationsResponse {
    data!: TranslationKeyModel[] | null;

    constructor(data?: IGetTranslationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TranslationKeyModel.fromJS(item));
            }
            else {
                this.data = null as any;
            }
        }
    }

    static fromJS(data: any): GetTranslationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTranslationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGetTranslationsResponse {
    data: TranslationKeyModel[] | null;
}

export class GetUserHierarchyResponse implements IGetUserHierarchyResponse {
    data!: UserHierarchyDivisionModel | null;

    constructor(data?: IGetUserHierarchyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserHierarchyDivisionModel.fromJS(_data["data"]) : null as any;
        }
    }

    static fromJS(data: any): GetUserHierarchyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserHierarchyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : null as any;
        return data;
    }
}

export interface IGetUserHierarchyResponse {
    data: UserHierarchyDivisionModel | null;
}

export class HierarchyChildBudgetModel implements IHierarchyChildBudgetModel {
    id!: string;
    name!: string;
    assignedBudget!: any | null;
    usedBudget!: any;
    dohCost!: any;
    latestPlanId!: string | null;
    latestPlanState!: PlanState | null;
    isReadyForInvestplan!: boolean | null;

    constructor(data?: IHierarchyChildBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.assignedBudget = _data["assignedBudget"] !== undefined ? _data["assignedBudget"] : null as any;
            this.usedBudget = _data["usedBudget"] !== undefined ? _data["usedBudget"] : null as any;
            this.dohCost = _data["dohCost"] !== undefined ? _data["dohCost"] : null as any;
            this.latestPlanId = _data["latestPlanId"] !== undefined ? _data["latestPlanId"] : null as any;
            this.latestPlanState = _data["latestPlanState"] !== undefined ? _data["latestPlanState"] : null as any;
            this.isReadyForInvestplan = _data["isReadyForInvestplan"] !== undefined ? _data["isReadyForInvestplan"] : null as any;
        }
    }

    static fromJS(data: any): HierarchyChildBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyChildBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["assignedBudget"] = this.assignedBudget !== undefined ? this.assignedBudget : null as any;
        data["usedBudget"] = this.usedBudget !== undefined ? this.usedBudget : null as any;
        data["dohCost"] = this.dohCost !== undefined ? this.dohCost : null as any;
        data["latestPlanId"] = this.latestPlanId !== undefined ? this.latestPlanId : null as any;
        data["latestPlanState"] = this.latestPlanState !== undefined ? this.latestPlanState : null as any;
        data["isReadyForInvestplan"] = this.isReadyForInvestplan !== undefined ? this.isReadyForInvestplan : null as any;
        return data;
    }
}

export interface IHierarchyChildBudgetModel {
    id: string;
    name: string;
    assignedBudget: any | null;
    usedBudget: any;
    dohCost: any;
    latestPlanId: string | null;
    latestPlanState: PlanState | null;
    isReadyForInvestplan: boolean | null;
}

export class HierarchyDataModel implements IHierarchyDataModel {
    id!: string;
    name!: string;
    budget!: any | null;
    children!: HierarchyChildBudgetModel[];

    constructor(data?: IHierarchyDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.children = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.budget = _data["budget"] !== undefined ? _data["budget"] : null as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(HierarchyChildBudgetModel.fromJS(item));
            }
            else {
                this.children = null as any;
            }
        }
    }

    static fromJS(data: any): HierarchyDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["budget"] = this.budget !== undefined ? this.budget : null as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IHierarchyDataModel {
    id: string;
    name: string;
    budget: any | null;
    children: HierarchyChildBudgetModel[];
}

export class HierarchyTrackingDataModel implements IHierarchyTrackingDataModel {
    plannedBudget!: any;
    usedBudget!: any;
    capexTotal!: any;
    dohTotal!: any;
    monthlyData!: MonthlyTrackingDataModel[];
    inventoryNumberTotals!: InventoryNumberTotalModel[];

    constructor(data?: IHierarchyTrackingDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.monthlyData = [];
            this.inventoryNumberTotals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedBudget = _data["plannedBudget"] !== undefined ? _data["plannedBudget"] : null as any;
            this.usedBudget = _data["usedBudget"] !== undefined ? _data["usedBudget"] : null as any;
            this.capexTotal = _data["capexTotal"] !== undefined ? _data["capexTotal"] : null as any;
            this.dohTotal = _data["dohTotal"] !== undefined ? _data["dohTotal"] : null as any;
            if (Array.isArray(_data["monthlyData"])) {
                this.monthlyData = [] as any;
                for (let item of _data["monthlyData"])
                    this.monthlyData!.push(MonthlyTrackingDataModel.fromJS(item));
            }
            else {
                this.monthlyData = null as any;
            }
            if (Array.isArray(_data["inventoryNumberTotals"])) {
                this.inventoryNumberTotals = [] as any;
                for (let item of _data["inventoryNumberTotals"])
                    this.inventoryNumberTotals!.push(InventoryNumberTotalModel.fromJS(item));
            }
            else {
                this.inventoryNumberTotals = null as any;
            }
        }
    }

    static fromJS(data: any): HierarchyTrackingDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyTrackingDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedBudget"] = this.plannedBudget !== undefined ? this.plannedBudget : null as any;
        data["usedBudget"] = this.usedBudget !== undefined ? this.usedBudget : null as any;
        data["capexTotal"] = this.capexTotal !== undefined ? this.capexTotal : null as any;
        data["dohTotal"] = this.dohTotal !== undefined ? this.dohTotal : null as any;
        if (Array.isArray(this.monthlyData)) {
            data["monthlyData"] = [];
            for (let item of this.monthlyData)
                data["monthlyData"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.inventoryNumberTotals)) {
            data["inventoryNumberTotals"] = [];
            for (let item of this.inventoryNumberTotals)
                data["inventoryNumberTotals"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IHierarchyTrackingDataModel {
    plannedBudget: any;
    usedBudget: any;
    capexTotal: any;
    dohTotal: any;
    monthlyData: MonthlyTrackingDataModel[];
    inventoryNumberTotals: InventoryNumberTotalModel[];
}

export enum HierarchyType {
    Region = "Region",
    Country = "Country",
}

export class HierarchyUserModel implements IHierarchyUserModel {
    id!: string;
    email!: string;
    firstName!: string | null;
    lastName!: string | null;
    isPending!: boolean;

    constructor(data?: IHierarchyUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.isPending = _data["isPending"] !== undefined ? _data["isPending"] : null as any;
        }
    }

    static fromJS(data: any): HierarchyUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["isPending"] = this.isPending !== undefined ? this.isPending : null as any;
        return data;
    }
}

export interface IHierarchyUserModel {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    isPending: boolean;
}

export class InventoryNumberModel implements IInventoryNumberModel {
    id!: string;
    name!: string;
    number!: string;

    constructor(data?: IInventoryNumberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.number = _data["number"] !== undefined ? _data["number"] : null as any;
        }
    }

    static fromJS(data: any): InventoryNumberModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryNumberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["number"] = this.number !== undefined ? this.number : null as any;
        return data;
    }
}

export interface IInventoryNumberModel {
    id: string;
    name: string;
    number: string;
}

export class InventoryNumberTotalModel implements IInventoryNumberTotalModel {
    inventoryNumberId!: string;
    label!: string;
    totalCost!: any;

    constructor(data?: IInventoryNumberTotalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inventoryNumberId = _data["inventoryNumberId"] !== undefined ? _data["inventoryNumberId"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.totalCost = _data["totalCost"] !== undefined ? _data["totalCost"] : null as any;
        }
    }

    static fromJS(data: any): InventoryNumberTotalModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryNumberTotalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryNumberId"] = this.inventoryNumberId !== undefined ? this.inventoryNumberId : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["totalCost"] = this.totalCost !== undefined ? this.totalCost : null as any;
        return data;
    }
}

export interface IInventoryNumberTotalModel {
    inventoryNumberId: string;
    label: string;
    totalCost: any;
}

export class InvestmentModel implements IInvestmentModel {
    id!: string;
    quantity!: any;
    priority!: ItemPriority | null;
    lifetimeInMonths!: any | null;
    estimatedCost!: any;
    actualCost!: any;
    estimatedDate!: Date | null;
    trackedQuantity!: any;

    constructor(data?: IInvestmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.lifetimeInMonths = _data["lifetimeInMonths"] !== undefined ? _data["lifetimeInMonths"] : null as any;
            this.estimatedCost = _data["estimatedCost"] !== undefined ? _data["estimatedCost"] : null as any;
            this.actualCost = _data["actualCost"] !== undefined ? _data["actualCost"] : null as any;
            this.estimatedDate = _data["estimatedDate"] ? new Date(_data["estimatedDate"].toString()) : null as any;
            this.trackedQuantity = _data["trackedQuantity"] !== undefined ? _data["trackedQuantity"] : null as any;
        }
    }

    static fromJS(data: any): InvestmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["lifetimeInMonths"] = this.lifetimeInMonths !== undefined ? this.lifetimeInMonths : null as any;
        data["estimatedCost"] = this.estimatedCost !== undefined ? this.estimatedCost : null as any;
        data["actualCost"] = this.actualCost !== undefined ? this.actualCost : null as any;
        data["estimatedDate"] = this.estimatedDate ? formatDate(this.estimatedDate) : null as any;
        data["trackedQuantity"] = this.trackedQuantity !== undefined ? this.trackedQuantity : null as any;
        return data;
    }
}

export interface IInvestmentModel {
    id: string;
    quantity: any;
    priority: ItemPriority | null;
    lifetimeInMonths: any | null;
    estimatedCost: any;
    actualCost: any;
    estimatedDate: Date | null;
    trackedQuantity: any;
}

export class InvitedMemberModel implements IInvitedMemberModel {
    userId!: string | null;
    name!: string;
    email!: string;
    invitationDate!: Date;
    latestSubmissionDate!: Date;
    inviterId!: string | null;
    inviterName!: string | null;
    inviterEmail!: string | null;

    constructor(data?: IInvitedMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.invitationDate = _data["invitationDate"] ? new Date(_data["invitationDate"].toString()) : null as any;
            this.latestSubmissionDate = _data["latestSubmissionDate"] ? new Date(_data["latestSubmissionDate"].toString()) : null as any;
            this.inviterId = _data["inviterId"] !== undefined ? _data["inviterId"] : null as any;
            this.inviterName = _data["inviterName"] !== undefined ? _data["inviterName"] : null as any;
            this.inviterEmail = _data["inviterEmail"] !== undefined ? _data["inviterEmail"] : null as any;
        }
    }

    static fromJS(data: any): InvitedMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvitedMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["invitationDate"] = this.invitationDate ? formatDate(this.invitationDate) : null as any;
        data["latestSubmissionDate"] = this.latestSubmissionDate ? formatDate(this.latestSubmissionDate) : null as any;
        data["inviterId"] = this.inviterId !== undefined ? this.inviterId : null as any;
        data["inviterName"] = this.inviterName !== undefined ? this.inviterName : null as any;
        data["inviterEmail"] = this.inviterEmail !== undefined ? this.inviterEmail : null as any;
        return data;
    }
}

export interface IInvitedMemberModel {
    userId: string | null;
    name: string;
    email: string;
    invitationDate: Date;
    latestSubmissionDate: Date;
    inviterId: string | null;
    inviterName: string | null;
    inviterEmail: string | null;
}

export enum ItemPriority {
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export class LanguageModel implements ILanguageModel {
    languageCode!: string;

    constructor(data?: ILanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["languageCode"] !== undefined ? _data["languageCode"] : null as any;
        }
    }

    static fromJS(data: any): LanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode !== undefined ? this.languageCode : null as any;
        return data;
    }
}

export interface ILanguageModel {
    languageCode: string;
}

export class MinimalCatalogItemModel implements IMinimalCatalogItemModel {
    id!: string;
    name!: string;
    divisionId!: string;

    constructor(data?: IMinimalCatalogItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.divisionId = _data["divisionId"] !== undefined ? _data["divisionId"] : null as any;
        }
    }

    static fromJS(data: any): MinimalCatalogItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new MinimalCatalogItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["divisionId"] = this.divisionId !== undefined ? this.divisionId : null as any;
        return data;
    }
}

export interface IMinimalCatalogItemModel {
    id: string;
    name: string;
    divisionId: string;
}

export class MinimalCountryModel implements IMinimalCountryModel {
    id!: string;
    name!: string;
    canViewDashboard!: boolean;
    branches!: BranchModel[];

    constructor(data?: IMinimalCountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.branches = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.canViewDashboard = _data["canViewDashboard"] !== undefined ? _data["canViewDashboard"] : null as any;
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(BranchModel.fromJS(item));
            }
            else {
                this.branches = null as any;
            }
        }
    }

    static fromJS(data: any): MinimalCountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new MinimalCountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["canViewDashboard"] = this.canViewDashboard !== undefined ? this.canViewDashboard : null as any;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IMinimalCountryModel {
    id: string;
    name: string;
    canViewDashboard: boolean;
    branches: BranchModel[];
}

export class MinimalFiscalYearModel implements IMinimalFiscalYearModel {
    fiscalYearId!: string;
    year!: any;
    deadlineDate!: Date | null;

    constructor(data?: IMinimalFiscalYearModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.deadlineDate = _data["deadlineDate"] ? new Date(_data["deadlineDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): MinimalFiscalYearModel {
        data = typeof data === 'object' ? data : {};
        let result = new MinimalFiscalYearModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["deadlineDate"] = this.deadlineDate ? formatDate(this.deadlineDate) : null as any;
        return data;
    }
}

export interface IMinimalFiscalYearModel {
    fiscalYearId: string;
    year: any;
    deadlineDate: Date | null;
}

export class MonthlyTrackingDataModel implements IMonthlyTrackingDataModel {
    month!: any;
    inventoryNumberId!: string;
    inventoryNumberLabel!: string;
    cost!: any;

    constructor(data?: IMonthlyTrackingDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"] !== undefined ? _data["month"] : null as any;
            this.inventoryNumberId = _data["inventoryNumberId"] !== undefined ? _data["inventoryNumberId"] : null as any;
            this.inventoryNumberLabel = _data["inventoryNumberLabel"] !== undefined ? _data["inventoryNumberLabel"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
        }
    }

    static fromJS(data: any): MonthlyTrackingDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyTrackingDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month !== undefined ? this.month : null as any;
        data["inventoryNumberId"] = this.inventoryNumberId !== undefined ? this.inventoryNumberId : null as any;
        data["inventoryNumberLabel"] = this.inventoryNumberLabel !== undefined ? this.inventoryNumberLabel : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        return data;
    }
}

export interface IMonthlyTrackingDataModel {
    month: any;
    inventoryNumberId: string;
    inventoryNumberLabel: string;
    cost: any;
}

export class NotifiedCountryModel implements INotifiedCountryModel {
    countryId!: string;
    recipientCount!: any;
    sentCount!: any;
    sentAt!: Date | null;

    constructor(data?: INotifiedCountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.recipientCount = _data["recipientCount"] !== undefined ? _data["recipientCount"] : null as any;
            this.sentCount = _data["sentCount"] !== undefined ? _data["sentCount"] : null as any;
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): NotifiedCountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotifiedCountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["recipientCount"] = this.recipientCount !== undefined ? this.recipientCount : null as any;
        data["sentCount"] = this.sentCount !== undefined ? this.sentCount : null as any;
        data["sentAt"] = this.sentAt ? this.sentAt.toISOString() : null as any;
        return data;
    }
}

export interface INotifiedCountryModel {
    countryId: string;
    recipientCount: any;
    sentCount: any;
    sentAt: Date | null;
}

export class NotifyHeadsOfCountryCommandResult implements INotifyHeadsOfCountryCommandResult {
    countries!: NotifiedCountryModel[];

    constructor(data?: INotifyHeadsOfCountryCommandResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.countries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(NotifiedCountryModel.fromJS(item));
            }
            else {
                this.countries = null as any;
            }
        }
    }

    static fromJS(data: any): NotifyHeadsOfCountryCommandResult {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyHeadsOfCountryCommandResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface INotifyHeadsOfCountryCommandResult {
    countries: NotifiedCountryModel[];
}

export class NotifyHeadsOfCountryModel implements INotifyHeadsOfCountryModel {
    countryIds!: string[];

    constructor(data?: INotifyHeadsOfCountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.countryIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countryIds"])) {
                this.countryIds = [] as any;
                for (let item of _data["countryIds"])
                    this.countryIds!.push(item);
            }
            else {
                this.countryIds = null as any;
            }
        }
    }

    static fromJS(data: any): NotifyHeadsOfCountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyHeadsOfCountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countryIds)) {
            data["countryIds"] = [];
            for (let item of this.countryIds)
                data["countryIds"].push(item);
        }
        return data;
    }
}

export interface INotifyHeadsOfCountryModel {
    countryIds: string[];
}

export class PlanActivityModel implements IPlanActivityModel {
    planId!: string;
    branchName!: string;
    version!: any;
    currentState!: PlanState;
    requestedBudget!: any;
    assignedBudget!: any;
    countryName!: string;
    regionName!: string;
    fiscalYear!: any;

    constructor(data?: IPlanActivityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planId = _data["planId"] !== undefined ? _data["planId"] : null as any;
            this.branchName = _data["branchName"] !== undefined ? _data["branchName"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.currentState = _data["currentState"] !== undefined ? _data["currentState"] : null as any;
            this.requestedBudget = _data["requestedBudget"] !== undefined ? _data["requestedBudget"] : null as any;
            this.assignedBudget = _data["assignedBudget"] !== undefined ? _data["assignedBudget"] : null as any;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null as any;
            this.regionName = _data["regionName"] !== undefined ? _data["regionName"] : null as any;
            this.fiscalYear = _data["fiscalYear"] !== undefined ? _data["fiscalYear"] : null as any;
        }
    }

    static fromJS(data: any): PlanActivityModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlanActivityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId !== undefined ? this.planId : null as any;
        data["branchName"] = this.branchName !== undefined ? this.branchName : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["currentState"] = this.currentState !== undefined ? this.currentState : null as any;
        data["requestedBudget"] = this.requestedBudget !== undefined ? this.requestedBudget : null as any;
        data["assignedBudget"] = this.assignedBudget !== undefined ? this.assignedBudget : null as any;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null as any;
        data["regionName"] = this.regionName !== undefined ? this.regionName : null as any;
        data["fiscalYear"] = this.fiscalYear !== undefined ? this.fiscalYear : null as any;
        return data;
    }
}

export interface IPlanActivityModel {
    planId: string;
    branchName: string;
    version: any;
    currentState: PlanState;
    requestedBudget: any;
    assignedBudget: any;
    countryName: string;
    regionName: string;
    fiscalYear: any;
}

export class PlanByUserModel implements IPlanByUserModel {
    id!: string;
    fiscalYear!: any;
    state!: PlanState;
    branch!: BranchModel;
    latestSubmissionDate!: Date;

    constructor(data?: IPlanByUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.branch = new BranchModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fiscalYear = _data["fiscalYear"] !== undefined ? _data["fiscalYear"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.branch = _data["branch"] ? BranchModel.fromJS(_data["branch"]) : new BranchModel();
            this.latestSubmissionDate = _data["latestSubmissionDate"] ? new Date(_data["latestSubmissionDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PlanByUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlanByUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fiscalYear"] = this.fiscalYear !== undefined ? this.fiscalYear : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["branch"] = this.branch ? this.branch.toJSON() : null as any;
        data["latestSubmissionDate"] = this.latestSubmissionDate ? formatDate(this.latestSubmissionDate) : null as any;
        return data;
    }
}

export interface IPlanByUserModel {
    id: string;
    fiscalYear: any;
    state: PlanState;
    branch: BranchModel;
    latestSubmissionDate: Date;
}

export class PlanCatalogItemModel implements IPlanCatalogItemModel {
    id!: string | null;
    catalogItemId!: string | null;
    catalogCategoryId!: string;
    identifier!: string | null;
    inventoryNumber!: string | null;
    availabilityState!: AvailabilityState | null;
    itemNumber!: any | null;
    name!: string;
    investment!: InvestmentModel | null;
    doh!: DohModel | null;
    deliveryTimeMonths!: string | null;
    conversationMessages!: ConversationMessageModel[];
    suggestedCostPerUnit!: any | null;
    suggestedLifetimeInMonths!: any | null;

    constructor(data?: IPlanCatalogItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.conversationMessages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.catalogItemId = _data["catalogItemId"] !== undefined ? _data["catalogItemId"] : null as any;
            this.catalogCategoryId = _data["catalogCategoryId"] !== undefined ? _data["catalogCategoryId"] : null as any;
            this.identifier = _data["identifier"] !== undefined ? _data["identifier"] : null as any;
            this.inventoryNumber = _data["inventoryNumber"] !== undefined ? _data["inventoryNumber"] : null as any;
            this.availabilityState = _data["availabilityState"] !== undefined ? _data["availabilityState"] : null as any;
            this.itemNumber = _data["itemNumber"] !== undefined ? _data["itemNumber"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.investment = _data["investment"] ? InvestmentModel.fromJS(_data["investment"]) : null as any;
            this.doh = _data["doh"] ? DohModel.fromJS(_data["doh"]) : null as any;
            this.deliveryTimeMonths = _data["deliveryTimeMonths"] !== undefined ? _data["deliveryTimeMonths"] : null as any;
            if (Array.isArray(_data["conversationMessages"])) {
                this.conversationMessages = [] as any;
                for (let item of _data["conversationMessages"])
                    this.conversationMessages!.push(ConversationMessageModel.fromJS(item));
            }
            else {
                this.conversationMessages = null as any;
            }
            this.suggestedCostPerUnit = _data["suggestedCostPerUnit"] !== undefined ? _data["suggestedCostPerUnit"] : null as any;
            this.suggestedLifetimeInMonths = _data["suggestedLifetimeInMonths"] !== undefined ? _data["suggestedLifetimeInMonths"] : null as any;
        }
    }

    static fromJS(data: any): PlanCatalogItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlanCatalogItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["catalogItemId"] = this.catalogItemId !== undefined ? this.catalogItemId : null as any;
        data["catalogCategoryId"] = this.catalogCategoryId !== undefined ? this.catalogCategoryId : null as any;
        data["identifier"] = this.identifier !== undefined ? this.identifier : null as any;
        data["inventoryNumber"] = this.inventoryNumber !== undefined ? this.inventoryNumber : null as any;
        data["availabilityState"] = this.availabilityState !== undefined ? this.availabilityState : null as any;
        data["itemNumber"] = this.itemNumber !== undefined ? this.itemNumber : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["investment"] = this.investment ? this.investment.toJSON() : null as any;
        data["doh"] = this.doh ? this.doh.toJSON() : null as any;
        data["deliveryTimeMonths"] = this.deliveryTimeMonths !== undefined ? this.deliveryTimeMonths : null as any;
        if (Array.isArray(this.conversationMessages)) {
            data["conversationMessages"] = [];
            for (let item of this.conversationMessages)
                data["conversationMessages"].push(item ? item.toJSON() : null as any);
        }
        data["suggestedCostPerUnit"] = this.suggestedCostPerUnit !== undefined ? this.suggestedCostPerUnit : null as any;
        data["suggestedLifetimeInMonths"] = this.suggestedLifetimeInMonths !== undefined ? this.suggestedLifetimeInMonths : null as any;
        return data;
    }
}

export interface IPlanCatalogItemModel {
    id: string | null;
    catalogItemId: string | null;
    catalogCategoryId: string;
    identifier: string | null;
    inventoryNumber: string | null;
    availabilityState: AvailabilityState | null;
    itemNumber: any | null;
    name: string;
    investment: InvestmentModel | null;
    doh: DohModel | null;
    deliveryTimeMonths: string | null;
    conversationMessages: ConversationMessageModel[];
    suggestedCostPerUnit: any | null;
    suggestedLifetimeInMonths: any | null;
}

export class PlanListEntryModel implements IPlanListEntryModel {
    id!: string;
    fiscalYear!: any;
    state!: PlanState;
    requestedBudget!: any;
    dohCost!: any;
    assignedBudget!: any | null;
    latestSubmissionDate!: Date;
    versions!: PlanVersionModel[];

    constructor(data?: IPlanListEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.versions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fiscalYear = _data["fiscalYear"] !== undefined ? _data["fiscalYear"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.requestedBudget = _data["requestedBudget"] !== undefined ? _data["requestedBudget"] : null as any;
            this.dohCost = _data["dohCost"] !== undefined ? _data["dohCost"] : null as any;
            this.assignedBudget = _data["assignedBudget"] !== undefined ? _data["assignedBudget"] : null as any;
            this.latestSubmissionDate = _data["latestSubmissionDate"] ? new Date(_data["latestSubmissionDate"].toString()) : null as any;
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(PlanVersionModel.fromJS(item));
            }
            else {
                this.versions = null as any;
            }
        }
    }

    static fromJS(data: any): PlanListEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlanListEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fiscalYear"] = this.fiscalYear !== undefined ? this.fiscalYear : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["requestedBudget"] = this.requestedBudget !== undefined ? this.requestedBudget : null as any;
        data["dohCost"] = this.dohCost !== undefined ? this.dohCost : null as any;
        data["assignedBudget"] = this.assignedBudget !== undefined ? this.assignedBudget : null as any;
        data["latestSubmissionDate"] = this.latestSubmissionDate ? formatDate(this.latestSubmissionDate) : null as any;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPlanListEntryModel {
    id: string;
    fiscalYear: any;
    state: PlanState;
    requestedBudget: any;
    dohCost: any;
    assignedBudget: any | null;
    latestSubmissionDate: Date;
    versions: PlanVersionModel[];
}

export class PlanModel implements IPlanModel {
    id!: string;
    fiscalYear!: any;
    version!: any;
    state!: PlanState;
    requestedBudget!: any;
    assignedBudget!: any | null;
    previousVersionId!: string | null;
    nextVersionId!: string | null;
    branchId!: string;
    branchIdentifier!: string;
    divisionId!: string | null;
    effectiveRole!: UserRole;
    changesRequestedMessage!: string | null;
    incomingPostponedInvestmentCount!: any;
    previousFiscalYear!: any | null;
    latestSubmissionDate!: Date | null;

    constructor(data?: IPlanModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fiscalYear = _data["fiscalYear"] !== undefined ? _data["fiscalYear"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.requestedBudget = _data["requestedBudget"] !== undefined ? _data["requestedBudget"] : null as any;
            this.assignedBudget = _data["assignedBudget"] !== undefined ? _data["assignedBudget"] : null as any;
            this.previousVersionId = _data["previousVersionId"] !== undefined ? _data["previousVersionId"] : null as any;
            this.nextVersionId = _data["nextVersionId"] !== undefined ? _data["nextVersionId"] : null as any;
            this.branchId = _data["branchId"] !== undefined ? _data["branchId"] : null as any;
            this.branchIdentifier = _data["branchIdentifier"] !== undefined ? _data["branchIdentifier"] : null as any;
            this.divisionId = _data["divisionId"] !== undefined ? _data["divisionId"] : null as any;
            this.effectiveRole = _data["effectiveRole"] !== undefined ? _data["effectiveRole"] : null as any;
            this.changesRequestedMessage = _data["changesRequestedMessage"] !== undefined ? _data["changesRequestedMessage"] : null as any;
            this.incomingPostponedInvestmentCount = _data["incomingPostponedInvestmentCount"] !== undefined ? _data["incomingPostponedInvestmentCount"] : null as any;
            this.previousFiscalYear = _data["previousFiscalYear"] !== undefined ? _data["previousFiscalYear"] : null as any;
            this.latestSubmissionDate = _data["latestSubmissionDate"] ? new Date(_data["latestSubmissionDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PlanModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlanModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fiscalYear"] = this.fiscalYear !== undefined ? this.fiscalYear : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["requestedBudget"] = this.requestedBudget !== undefined ? this.requestedBudget : null as any;
        data["assignedBudget"] = this.assignedBudget !== undefined ? this.assignedBudget : null as any;
        data["previousVersionId"] = this.previousVersionId !== undefined ? this.previousVersionId : null as any;
        data["nextVersionId"] = this.nextVersionId !== undefined ? this.nextVersionId : null as any;
        data["branchId"] = this.branchId !== undefined ? this.branchId : null as any;
        data["branchIdentifier"] = this.branchIdentifier !== undefined ? this.branchIdentifier : null as any;
        data["divisionId"] = this.divisionId !== undefined ? this.divisionId : null as any;
        data["effectiveRole"] = this.effectiveRole !== undefined ? this.effectiveRole : null as any;
        data["changesRequestedMessage"] = this.changesRequestedMessage !== undefined ? this.changesRequestedMessage : null as any;
        data["incomingPostponedInvestmentCount"] = this.incomingPostponedInvestmentCount !== undefined ? this.incomingPostponedInvestmentCount : null as any;
        data["previousFiscalYear"] = this.previousFiscalYear !== undefined ? this.previousFiscalYear : null as any;
        data["latestSubmissionDate"] = this.latestSubmissionDate ? formatDate(this.latestSubmissionDate) : null as any;
        return data;
    }
}

export interface IPlanModel {
    id: string;
    fiscalYear: any;
    version: any;
    state: PlanState;
    requestedBudget: any;
    assignedBudget: any | null;
    previousVersionId: string | null;
    nextVersionId: string | null;
    branchId: string;
    branchIdentifier: string;
    divisionId: string | null;
    effectiveRole: UserRole;
    changesRequestedMessage: string | null;
    incomingPostponedInvestmentCount: any;
    previousFiscalYear: any | null;
    latestSubmissionDate: Date | null;
}

export enum PlanState {
    Draft = "Draft",
    Submitted = "Submitted",
    Approved = "Approved",
    ChangesRequested = "ChangesRequested",
    Completed = "Completed",
}

export class PlanTaskModel implements IPlanTaskModel {
    id!: string;
    version!: any;
    branchName!: string;
    responsibleUserName!: string | null;
    dueDate!: Date | null;
    requestedBudget!: any;
    assignedBudget!: any;
    state!: PlanState;
    fiscalYear!: any;

    constructor(data?: IPlanTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.branchName = _data["branchName"] !== undefined ? _data["branchName"] : null as any;
            this.responsibleUserName = _data["responsibleUserName"] !== undefined ? _data["responsibleUserName"] : null as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : null as any;
            this.requestedBudget = _data["requestedBudget"] !== undefined ? _data["requestedBudget"] : null as any;
            this.assignedBudget = _data["assignedBudget"] !== undefined ? _data["assignedBudget"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.fiscalYear = _data["fiscalYear"] !== undefined ? _data["fiscalYear"] : null as any;
        }
    }

    static fromJS(data: any): PlanTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlanTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["branchName"] = this.branchName !== undefined ? this.branchName : null as any;
        data["responsibleUserName"] = this.responsibleUserName !== undefined ? this.responsibleUserName : null as any;
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : null as any;
        data["requestedBudget"] = this.requestedBudget !== undefined ? this.requestedBudget : null as any;
        data["assignedBudget"] = this.assignedBudget !== undefined ? this.assignedBudget : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["fiscalYear"] = this.fiscalYear !== undefined ? this.fiscalYear : null as any;
        return data;
    }
}

export interface IPlanTaskModel {
    id: string;
    version: any;
    branchName: string;
    responsibleUserName: string | null;
    dueDate: Date | null;
    requestedBudget: any;
    assignedBudget: any;
    state: PlanState;
    fiscalYear: any;
}

export class PlanVersionModel implements IPlanVersionModel {
    planId!: string;
    version!: any;
    requestedBudget!: any;
    dohCost!: any;
    state!: PlanState;
    changedByName!: string | null;
    changedAt!: Date;

    constructor(data?: IPlanVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planId = _data["planId"] !== undefined ? _data["planId"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.requestedBudget = _data["requestedBudget"] !== undefined ? _data["requestedBudget"] : null as any;
            this.dohCost = _data["dohCost"] !== undefined ? _data["dohCost"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.changedByName = _data["changedByName"] !== undefined ? _data["changedByName"] : null as any;
            this.changedAt = _data["changedAt"] ? new Date(_data["changedAt"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PlanVersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlanVersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId !== undefined ? this.planId : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["requestedBudget"] = this.requestedBudget !== undefined ? this.requestedBudget : null as any;
        data["dohCost"] = this.dohCost !== undefined ? this.dohCost : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["changedByName"] = this.changedByName !== undefined ? this.changedByName : null as any;
        data["changedAt"] = this.changedAt ? this.changedAt.toISOString() : null as any;
        return data;
    }
}

export interface IPlanVersionModel {
    planId: string;
    version: any;
    requestedBudget: any;
    dohCost: any;
    state: PlanState;
    changedByName: string | null;
    changedAt: Date;
}

export class PostponedInvestmentModel implements IPostponedInvestmentModel {
    id!: string;
    planItemId!: string;
    catalogItemId!: string | null;
    name!: string;
    identifier!: string | null;
    inventoryNumber!: string | null;
    quantity!: any;
    estimatedCost!: any;
    priority!: ItemPriority | null;
    lifetimeInMonths!: any | null;

    constructor(data?: IPostponedInvestmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.planItemId = _data["planItemId"] !== undefined ? _data["planItemId"] : null as any;
            this.catalogItemId = _data["catalogItemId"] !== undefined ? _data["catalogItemId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.identifier = _data["identifier"] !== undefined ? _data["identifier"] : null as any;
            this.inventoryNumber = _data["inventoryNumber"] !== undefined ? _data["inventoryNumber"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.estimatedCost = _data["estimatedCost"] !== undefined ? _data["estimatedCost"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.lifetimeInMonths = _data["lifetimeInMonths"] !== undefined ? _data["lifetimeInMonths"] : null as any;
        }
    }

    static fromJS(data: any): PostponedInvestmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostponedInvestmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["planItemId"] = this.planItemId !== undefined ? this.planItemId : null as any;
        data["catalogItemId"] = this.catalogItemId !== undefined ? this.catalogItemId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["identifier"] = this.identifier !== undefined ? this.identifier : null as any;
        data["inventoryNumber"] = this.inventoryNumber !== undefined ? this.inventoryNumber : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["estimatedCost"] = this.estimatedCost !== undefined ? this.estimatedCost : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["lifetimeInMonths"] = this.lifetimeInMonths !== undefined ? this.lifetimeInMonths : null as any;
        return data;
    }
}

export interface IPostponedInvestmentModel {
    id: string;
    planItemId: string;
    catalogItemId: string | null;
    name: string;
    identifier: string | null;
    inventoryNumber: string | null;
    quantity: any;
    estimatedCost: any;
    priority: ItemPriority | null;
    lifetimeInMonths: any | null;
}

export class PostponedInvestmentsDataModel implements IPostponedInvestmentsDataModel {
    previousFiscalYear!: any;
    previousYearPostponedInvestments!: PostponedInvestmentModel[];
    nextFiscalYear!: any;
    nextYearPostponedInvestments!: PostponedInvestmentModel[];

    constructor(data?: IPostponedInvestmentsDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.previousYearPostponedInvestments = [];
            this.nextYearPostponedInvestments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousFiscalYear = _data["previousFiscalYear"] !== undefined ? _data["previousFiscalYear"] : null as any;
            if (Array.isArray(_data["previousYearPostponedInvestments"])) {
                this.previousYearPostponedInvestments = [] as any;
                for (let item of _data["previousYearPostponedInvestments"])
                    this.previousYearPostponedInvestments!.push(PostponedInvestmentModel.fromJS(item));
            }
            else {
                this.previousYearPostponedInvestments = null as any;
            }
            this.nextFiscalYear = _data["nextFiscalYear"] !== undefined ? _data["nextFiscalYear"] : null as any;
            if (Array.isArray(_data["nextYearPostponedInvestments"])) {
                this.nextYearPostponedInvestments = [] as any;
                for (let item of _data["nextYearPostponedInvestments"])
                    this.nextYearPostponedInvestments!.push(PostponedInvestmentModel.fromJS(item));
            }
            else {
                this.nextYearPostponedInvestments = null as any;
            }
        }
    }

    static fromJS(data: any): PostponedInvestmentsDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostponedInvestmentsDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousFiscalYear"] = this.previousFiscalYear !== undefined ? this.previousFiscalYear : null as any;
        if (Array.isArray(this.previousYearPostponedInvestments)) {
            data["previousYearPostponedInvestments"] = [];
            for (let item of this.previousYearPostponedInvestments)
                data["previousYearPostponedInvestments"].push(item ? item.toJSON() : null as any);
        }
        data["nextFiscalYear"] = this.nextFiscalYear !== undefined ? this.nextFiscalYear : null as any;
        if (Array.isArray(this.nextYearPostponedInvestments)) {
            data["nextYearPostponedInvestments"] = [];
            for (let item of this.nextYearPostponedInvestments)
                data["nextYearPostponedInvestments"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPostponedInvestmentsDataModel {
    previousFiscalYear: any;
    previousYearPostponedInvestments: PostponedInvestmentModel[];
    nextFiscalYear: any;
    nextYearPostponedInvestments: PostponedInvestmentModel[];
}

export class ProblemDetails implements IProblemDetails {
    type!: string | null;
    title!: string | null;
    status!: any | null;
    detail!: string | null;
    instance!: string | null;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : null as any;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["instance"] = this.instance !== undefined ? this.instance : null as any;
        return data;
    }
}

export interface IProblemDetails {
    type: string | null;
    title: string | null;
    status: any | null;
    detail: string | null;
    instance: string | null;
}

export class ReplaceTrackingEntryItemRequest implements IReplaceTrackingEntryItemRequest {
    id!: string | null;
    date!: Date;
    amount!: any;
    cost!: any;

    constructor(data?: IReplaceTrackingEntryItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
        }
    }

    static fromJS(data: any): ReplaceTrackingEntryItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReplaceTrackingEntryItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["date"] = this.date ? formatDate(this.date) : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        return data;
    }
}

export interface IReplaceTrackingEntryItemRequest {
    id: string | null;
    date: Date;
    amount: any;
    cost: any;
}

export class SetBranchBudgetModel implements ISetBranchBudgetModel {
    branchBudgets!: BranchBudgetItemModel[];

    constructor(data?: ISetBranchBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.branchBudgets = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branchBudgets"])) {
                this.branchBudgets = [] as any;
                for (let item of _data["branchBudgets"])
                    this.branchBudgets!.push(BranchBudgetItemModel.fromJS(item));
            }
            else {
                this.branchBudgets = null as any;
            }
        }
    }

    static fromJS(data: any): SetBranchBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetBranchBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branchBudgets)) {
            data["branchBudgets"] = [];
            for (let item of this.branchBudgets)
                data["branchBudgets"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISetBranchBudgetModel {
    branchBudgets: BranchBudgetItemModel[];
}

export class SetCountryBudgetModel implements ISetCountryBudgetModel {
    countryBudgets!: CountryBudgetItemModel[];

    constructor(data?: ISetCountryBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.countryBudgets = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countryBudgets"])) {
                this.countryBudgets = [] as any;
                for (let item of _data["countryBudgets"])
                    this.countryBudgets!.push(CountryBudgetItemModel.fromJS(item));
            }
            else {
                this.countryBudgets = null as any;
            }
        }
    }

    static fromJS(data: any): SetCountryBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetCountryBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countryBudgets)) {
            data["countryBudgets"] = [];
            for (let item of this.countryBudgets)
                data["countryBudgets"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISetCountryBudgetModel {
    countryBudgets: CountryBudgetItemModel[];
}

export class SetCurrencyCountriesModel implements ISetCurrencyCountriesModel {
    countryIds!: string[];

    constructor(data?: ISetCurrencyCountriesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.countryIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countryIds"])) {
                this.countryIds = [] as any;
                for (let item of _data["countryIds"])
                    this.countryIds!.push(item);
            }
            else {
                this.countryIds = null as any;
            }
        }
    }

    static fromJS(data: any): SetCurrencyCountriesModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetCurrencyCountriesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countryIds)) {
            data["countryIds"] = [];
            for (let item of this.countryIds)
                data["countryIds"].push(item);
        }
        return data;
    }
}

export interface ISetCurrencyCountriesModel {
    countryIds: string[];
}

export class SetRegionBudgetModel implements ISetRegionBudgetModel {
    amount!: any | null;

    constructor(data?: ISetRegionBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static fromJS(data: any): SetRegionBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetRegionBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        return data;
    }
}

export interface ISetRegionBudgetModel {
    amount: any | null;
}

export class SharePlanModel implements ISharePlanModel {
    emails!: string[];
    latestSubmissionDate!: Date | null;

    constructor(data?: ISharePlanModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.emails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            else {
                this.emails = null as any;
            }
            this.latestSubmissionDate = _data["latestSubmissionDate"] ? new Date(_data["latestSubmissionDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): SharePlanModel {
        data = typeof data === 'object' ? data : {};
        let result = new SharePlanModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["latestSubmissionDate"] = this.latestSubmissionDate ? formatDate(this.latestSubmissionDate) : null as any;
        return data;
    }
}

export interface ISharePlanModel {
    emails: string[];
    latestSubmissionDate: Date | null;
}

export class SyncUserModel implements ISyncUserModel {
    email!: string;
    firstName!: string | null;
    lastName!: string | null;
    profilePictureUrl!: string | null;
    shareCode!: string | null;

    constructor(data?: ISyncUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.profilePictureUrl = _data["profilePictureUrl"] !== undefined ? _data["profilePictureUrl"] : null as any;
            this.shareCode = _data["shareCode"] !== undefined ? _data["shareCode"] : null as any;
        }
    }

    static fromJS(data: any): SyncUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new SyncUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["profilePictureUrl"] = this.profilePictureUrl !== undefined ? this.profilePictureUrl : null as any;
        data["shareCode"] = this.shareCode !== undefined ? this.shareCode : null as any;
        return data;
    }
}

export interface ISyncUserModel {
    email: string;
    firstName: string | null;
    lastName: string | null;
    profilePictureUrl: string | null;
    shareCode: string | null;
}

export class TrackingEntryModel implements ITrackingEntryModel {
    id!: string;
    date!: Date;
    amount!: any;
    cost!: any;
    createdBy!: string;
    createdDate!: Date;

    constructor(data?: ITrackingEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : null as any;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): TrackingEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["date"] = this.date ? formatDate(this.date) : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["cost"] = this.cost !== undefined ? this.cost : null as any;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        return data;
    }
}

export interface ITrackingEntryModel {
    id: string;
    date: Date;
    amount: any;
    cost: any;
    createdBy: string;
    createdDate: Date;
}

export class TranslationEntryModel implements ITranslationEntryModel {
    languageCode!: string;
    value!: string | null;

    constructor(data?: ITranslationEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["languageCode"] !== undefined ? _data["languageCode"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): TranslationEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode !== undefined ? this.languageCode : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export interface ITranslationEntryModel {
    languageCode: string;
    value: string | null;
}

export class TranslationKeyModel implements ITranslationKeyModel {
    key!: string;
    entries!: TranslationEntryModel[];

    constructor(data?: ITranslationKeyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.entries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(TranslationEntryModel.fromJS(item));
            }
            else {
                this.entries = null as any;
            }
        }
    }

    static fromJS(data: any): TranslationKeyModel {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationKeyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ITranslationKeyModel {
    key: string;
    entries: TranslationEntryModel[];
}

export class UpdateDirectOverheadModel implements IUpdateDirectOverheadModel {
    quantity!: any;
    estimatedCost!: any;
    estimatedDate!: Date;
    realizedDate!: Date | null;
    actualCost!: any | null;

    constructor(data?: IUpdateDirectOverheadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.estimatedCost = _data["estimatedCost"] !== undefined ? _data["estimatedCost"] : null as any;
            this.estimatedDate = _data["estimatedDate"] ? new Date(_data["estimatedDate"].toString()) : null as any;
            this.realizedDate = _data["realizedDate"] ? new Date(_data["realizedDate"].toString()) : null as any;
            this.actualCost = _data["actualCost"] !== undefined ? _data["actualCost"] : null as any;
        }
    }

    static fromJS(data: any): UpdateDirectOverheadModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDirectOverheadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["estimatedCost"] = this.estimatedCost !== undefined ? this.estimatedCost : null as any;
        data["estimatedDate"] = this.estimatedDate ? formatDate(this.estimatedDate) : null as any;
        data["realizedDate"] = this.realizedDate ? formatDate(this.realizedDate) : null as any;
        data["actualCost"] = this.actualCost !== undefined ? this.actualCost : null as any;
        return data;
    }
}

export interface IUpdateDirectOverheadModel {
    quantity: any;
    estimatedCost: any;
    estimatedDate: Date;
    realizedDate: Date | null;
    actualCost: any | null;
}

export class UpdateInvestmentModel implements IUpdateInvestmentModel {
    quantity!: any;
    priority!: ItemPriority;
    lifetimeInMonths!: any;
    estimatedCost!: any;
    estimatedDate!: Date;

    constructor(data?: IUpdateInvestmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : null as any;
            this.lifetimeInMonths = _data["lifetimeInMonths"] !== undefined ? _data["lifetimeInMonths"] : null as any;
            this.estimatedCost = _data["estimatedCost"] !== undefined ? _data["estimatedCost"] : null as any;
            this.estimatedDate = _data["estimatedDate"] ? new Date(_data["estimatedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): UpdateInvestmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvestmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["priority"] = this.priority !== undefined ? this.priority : null as any;
        data["lifetimeInMonths"] = this.lifetimeInMonths !== undefined ? this.lifetimeInMonths : null as any;
        data["estimatedCost"] = this.estimatedCost !== undefined ? this.estimatedCost : null as any;
        data["estimatedDate"] = this.estimatedDate ? formatDate(this.estimatedDate) : null as any;
        return data;
    }
}

export interface IUpdateInvestmentModel {
    quantity: any;
    priority: ItemPriority;
    lifetimeInMonths: any;
    estimatedCost: any;
    estimatedDate: Date;
}

export enum UserAssignmentLevel {
    Division = "Division",
    Region = "Region",
    Country = "Country",
    Branch = "Branch",
}

export class UserHierarchyBranchModel implements IUserHierarchyBranchModel {
    id!: string;
    name!: string;
    users!: HierarchyUserModel[];

    constructor(data?: IUserHierarchyBranchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(HierarchyUserModel.fromJS(item));
            }
            else {
                this.users = null as any;
            }
        }
    }

    static fromJS(data: any): UserHierarchyBranchModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserHierarchyBranchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IUserHierarchyBranchModel {
    id: string;
    name: string;
    users: HierarchyUserModel[];
}

export class UserHierarchyCountryModel implements IUserHierarchyCountryModel {
    id!: string;
    name!: string;
    users!: HierarchyUserModel[];
    branches!: UserHierarchyBranchModel[];

    constructor(data?: IUserHierarchyCountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.users = [];
            this.branches = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(HierarchyUserModel.fromJS(item));
            }
            else {
                this.users = null as any;
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(UserHierarchyBranchModel.fromJS(item));
            }
            else {
                this.branches = null as any;
            }
        }
    }

    static fromJS(data: any): UserHierarchyCountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserHierarchyCountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IUserHierarchyCountryModel {
    id: string;
    name: string;
    users: HierarchyUserModel[];
    branches: UserHierarchyBranchModel[];
}

export class UserHierarchyDivisionModel implements IUserHierarchyDivisionModel {
    id!: string;
    name!: string;
    users!: HierarchyUserModel[];
    regions!: UserHierarchyRegionModel[];

    constructor(data?: IUserHierarchyDivisionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.users = [];
            this.regions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(HierarchyUserModel.fromJS(item));
            }
            else {
                this.users = null as any;
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(UserHierarchyRegionModel.fromJS(item));
            }
            else {
                this.regions = null as any;
            }
        }
    }

    static fromJS(data: any): UserHierarchyDivisionModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserHierarchyDivisionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IUserHierarchyDivisionModel {
    id: string;
    name: string;
    users: HierarchyUserModel[];
    regions: UserHierarchyRegionModel[];
}

export class UserHierarchyRegionModel implements IUserHierarchyRegionModel {
    id!: string;
    name!: string;
    users!: HierarchyUserModel[];
    countries!: UserHierarchyCountryModel[];

    constructor(data?: IUserHierarchyRegionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.users = [];
            this.countries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(HierarchyUserModel.fromJS(item));
            }
            else {
                this.users = null as any;
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(UserHierarchyCountryModel.fromJS(item));
            }
            else {
                this.countries = null as any;
            }
        }
    }

    static fromJS(data: any): UserHierarchyRegionModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserHierarchyRegionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IUserHierarchyRegionModel {
    id: string;
    name: string;
    users: HierarchyUserModel[];
    countries: UserHierarchyCountryModel[];
}

export class UserListItemModel implements IUserListItemModel {
    id!: string;
    username!: string;
    firstName!: string | null;
    lastName!: string | null;
    isPending!: boolean;

    constructor(data?: IUserListItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.isPending = _data["isPending"] !== undefined ? _data["isPending"] : null as any;
        }
    }

    static fromJS(data: any): UserListItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserListItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["isPending"] = this.isPending !== undefined ? this.isPending : null as any;
        return data;
    }
}

export interface IUserListItemModel {
    id: string;
    username: string;
    firstName: string | null;
    lastName: string | null;
    isPending: boolean;
}

export class UserModel implements IUserModel {
    userName!: string;
    isSuperAdmin!: boolean;
    firstName!: string | null;
    divisionIds!: string[];
    regionIds!: string[];

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.divisionIds = [];
            this.regionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : null as any;
            this.isSuperAdmin = _data["isSuperAdmin"] !== undefined ? _data["isSuperAdmin"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            if (Array.isArray(_data["divisionIds"])) {
                this.divisionIds = [] as any;
                for (let item of _data["divisionIds"])
                    this.divisionIds!.push(item);
            }
            else {
                this.divisionIds = null as any;
            }
            if (Array.isArray(_data["regionIds"])) {
                this.regionIds = [] as any;
                for (let item of _data["regionIds"])
                    this.regionIds!.push(item);
            }
            else {
                this.regionIds = null as any;
            }
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : null as any;
        data["isSuperAdmin"] = this.isSuperAdmin !== undefined ? this.isSuperAdmin : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        if (Array.isArray(this.divisionIds)) {
            data["divisionIds"] = [];
            for (let item of this.divisionIds)
                data["divisionIds"].push(item);
        }
        if (Array.isArray(this.regionIds)) {
            data["regionIds"] = [];
            for (let item of this.regionIds)
                data["regionIds"].push(item);
        }
        return data;
    }
}

export interface IUserModel {
    userName: string;
    isSuperAdmin: boolean;
    firstName: string | null;
    divisionIds: string[];
    regionIds: string[];
}

export enum UserRole {
    User = "User",
    PowerUser = "PowerUser",
    Admin = "Admin",
    SuperAdmin = "SuperAdmin",
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}